module.exports = [
	{
		"code": "MS90EC1",
		"partnumber": "MS90E",
		"previewname": "MS90E",
		"name": "MS90E",
		"price": 2400,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from recyclable stainless steel and assembled with meticulous attention to detail. Designed, engineered and assembled in Long Island City, NY to the most exacting standards, our generators are clean, green, virtually silent, and ultra-efficient.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: UP TO 71 Cu Ft<BR>KW: 5<BR>Wire Size*: 10<BR>Dimensions** : 14 ½” L x 14 ¾” H x 6 ¾” D<BR>Water Usage Gallons***: 0.67<BR>Shipping Wt. (lbs)**** : 27<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"images": {
			"thumbnail": "MS90E-400E.jpg",
			"folder": "generators/",
			"scene": "MS-90-400.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/0e9b7d91-2a0a-478d-9425-797faf20a8e4.pdf"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 1
			},
			"zIndex": {
				"generators": 1
			},
			"series": "90-400"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": false
		}
	},
	{
		"code": "MS150EC1",
		"partnumber": "MS150E",
		"previewname": "MS150E",
		"name": "MS150E",
		"price": 3000,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from recyclable stainless steel and assembled with meticulous attention to detail. Designed, engineered and assembled in Long Island City, NY to the most exacting standards, our generators are clean, green, virtually silent, and ultra-efficient.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: 72 - 107<BR>KW: 6<BR>Wire Size*: 8<BR>Dimensions** : 14 ½” L x 14 ¾” H x 6 ¾” D<BR>Water Usage Gallons***: 0.80<BR>Shipping Wt. (lbs)**** : 27<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/0e9b7d91-2a0a-478d-9425-797faf20a8e4.pdf"
		},
		"images": {
			"thumbnail": "MS90E-400E.jpg",
			"folder": "generators/",
			"scene": "MS-90-400.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 2
			},
			"zIndex": {
				"generators": 2
			},
			"series": "90-400"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": false
		}
	},
	{
		"code": "MS225EC1",
		"partnumber": "MS225E",
		"previewname": "MS225E",
		"name": "MS225E",
		"price": 3450,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from recyclable stainless steel and assembled with meticulous attention to detail. Designed, engineered and assembled in Long Island City, NY to the most exacting standards, our generators are clean, green, virtually silent, and ultra-efficient.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: 108 - 161<BR>KW: 7.5<BR>Wire Size*: 8<BR>Dimensions** : 14 ½” L x 14 ¾” H x 6 ¾” D<BR>Water Usage Gallons***: 1.0<BR>Shipping Wt. (lbs)**** : 27<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/0e9b7d91-2a0a-478d-9425-797faf20a8e4.pdf"
		},
		"images": {
			"thumbnail": "MS90E-400E.jpg",
			"folder": "generators/",
			"scene": "MS-90-400.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 3
			},
			"zIndex": {
				"generators": 3
			},
			"series": "90-400"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": false
		}
	},
	{
		"code": "MS400EC1",
		"partnumber": "MS400E",
		"previewname": "MS400E",
		"name": "MS400E",
		"price": 3675,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from recyclable stainless steel and assembled with meticulous attention to detail. Designed, engineered and assembled in Long Island City, NY to the most exacting standards, our generators are clean, green, virtually silent, and ultra-efficient.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: 162 - 257<BR>KW: 9<BR>Wire Size*: 8<BR>Dimensions** : 14 ½” L x 14 ¾” H x 6 ¾” D<BR>Water Usage Gallons***: 1.2<BR>Shipping Wt. (lbs)**** : 27<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/0e9b7d91-2a0a-478d-9425-797faf20a8e4.pdf"
		},
		"images": {
			"thumbnail": "MS90E-400E.jpg",
			"folder": "generators/",
			"scene": "MS-90-400.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 4
			},
			"zIndex": {
				"generators": 4
			},
			"series": "90-400"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": false
		}
	},
	{
		"code": "MSSUPER1EC1",
		"partnumber": "MSSUPER1E",
		"previewname": "MSSUPER1E",
		"name": "MSSUPER1E",
		"price": 4200,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from stainless steel and assembled with meticulous attention to detail. Every component is designed, designed and engineered in-house to the most exacting standards.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI>\\r\\n<LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: 258 - 339<BR>KW: 10<BR>Wire Size*: 8<BR>Dimensions** : 17” L x 18 ½” H x 7 ⅞ ” D<BR>Water Usage Gallons***: 1.4<BR>Shipping Wt. (lbs)**** : 39<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/cd5e7178-85a0-4af8-a1d5-52566d10b500.pdf"
		},
		"images": {
			"thumbnail": "MSSuper1E-3E.jpg",
			"folder": "generators/",
			"scene": "MS-Super-1-3.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 5
			},
			"zIndex": {
				"generators": 5
			},
			"series": "1-3"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": true
		}
	},
	{
		"code": "MSSUPER2EC1",
		"partnumber": "MSSUPER2E",
		"previewname": "MSSUPER2E",
		"name": "MSSUPER2E",
		"price": 4600,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from stainless steel and assembled with meticulous attention to detail. Every component is designed, designed and engineered in-house to the most exacting standards.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: 340 - 411 <BR>KW: 12<BR>Wire Size*: 6<BR>Dimensions** :17” L x 18 ½” H x 7 ⅞ ” D<BR>Water Usage Gallons***: 1.6<BR>Shipping Wt. (lbs)**** : 39<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/cd5e7178-85a0-4af8-a1d5-52566d10b500.pdf"
		},
		"images": {
			"thumbnail": "MSSuper1E-3E.jpg",
			"folder": "generators/",
			"scene": "MS-Super-1-3.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 6
			},
			"zIndex": {
				"generators": 6
			},
			"series": "1-3"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": true
		}
	},
	{
		"code": "MSSUPER3EC1",
		"partnumber": "MSSUPER3E",
		"previewname": "MSSUPER3E",
		"name": "MSSUPER3E",
		"price": 5150,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>eSeries Generators are crafted from stainless steel and assembled with meticulous attention to detail. Every component is designed, designed and engineered in-house to the most exacting standards.<ul><LI>Free from defects in materials and craftsmanship for its lifetime. MrSteam will repair or replace (at its option) a Generator which fails to conform to this warranty</LI><LI>Installs in areas such as a cabinet, closet, under a sealed bench or in an insulated attic</LI><LI>Exclusive micro processor operating system is the brains of our intelligent steam generator</LI><LI>Easily install spa therapy accessories or components such as AromaTherapy, ChromaTherapy, Steamlinx, and more</LI>\\r\\n<LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless steel inside and out</LI><LI>Designed to save water and energy. Uses less than two gallons of water vs 40 gallons for an ordinary bath</LI><li>60 minute automatic cutoff, low voltage board, designed for easy access safe service</li><li>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</li><li>Reliable, industrial grade, and the industries largest copper heating element heats fast and is easy to remove and service</li></ul>",
			"tech": "Total Room Volume: 412 - 482<BR>KW: 15<BR>Wire Size*: 4<BR>Dimensions** : 17” L x 18 ½” H x 7 ⅞ ” D<BR>Water Usage Gallons***: 2.0<BR>Shipping Wt. (lbs)**** : 39<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/cd5e7178-85a0-4af8-a1d5-52566d10b500.pdf"
		},
		"images": {
			"thumbnail": "MSSuper1E-3E.jpg",
			"folder": "generators/",
			"scene": "MS-Super-1-3.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 7
			},
			"zIndex": {
				"generators": 7
			},
			"series": "1-3"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": true
		}
	},
	{
		"code": "MX4EC1",
		"partnumber": "MX4E",
		"previewname": "MX4E",
		"name": "MX4E",
		"price": 6700,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>MAX Generators are built for large residential enclosures. These units are crafted from stainless steel and assembled with meticulous attention to detail. Every component is designed and engineered in-house to the most exacting standards.<ul><LI>Exclusive microprocessor operating system is the brains of our intelligent steam generator </LI><LI>All MrSteam residential steambath MAX Generators installed in the United States or Canada qualify for a limited lifetime warranty, for full warranty details visit: https://blog.mrsteam.com/wr</LI><LI>Industrial grade, large diameter copper heating element heats fast and is easy to remove and service</LI><LI>Modular Plug and Play connections for easy installation of spa therapy accessories or components such as AromaTherapy, ChromaTherapy, MusicTherapy, Steamlinx, and more </LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless-steel tank</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</LI><LI>60-minute electronic countdown shutdown with 75-minute limiting safety back-up</LI><LI>Electronic water-level control system and full-port drain valve</LI><LI>Built-in, low-voltage 24-volt control and ASME safety valve</LI></ul>",
			"tech": " Total Room Volume: 483 - 678<BR>KW: 20<BR>Wire Size*: 2<BR>Dimensions** : 27 ⅝” L x 20 ¾” H x 7 ⅞ ” D<BR>Water Usage Gallons***: 2.7<BR>Shipping Wt. (lbs)**** : 67<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR><BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/68f8ac0d-243e-4be3-ac85-561a12bb2993.pdf"
		},
		"images": {
			"thumbnail": "MX4E-6E.jpg",
			"folder": "generators/",
			"scene": "MS-Super-4-6.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 8
			},
			"zIndex": {
				"generators": 8
			},
			"series": "4-6"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": true
		}
	},
	{
		"code": "MX5EC1",
		"partnumber": "MX5E",
		"previewname": "MX5E",
		"name": "MX5E",
		"price": 7000,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>MAX Generators are built for large residential enclosures. These units are crafted from stainless steel and assembled with meticulous attention to detail. Every component is designed and engineered in-house to the most exacting standards.<ul><LI>Exclusive microprocessor operating system is the brains of our intelligent steam generator </LI><LI>All MrSteam residential steambath MAX Generators installed in the United States or Canada qualify for a limited lifetime warranty, for full warranty details visit: https://blog.mrsteam.com/wr</LI><LI>Industrial grade, large diameter copper heating element heats fast and is easy to remove and service</LI><LI>Modular Plug and Play connections for easy installation of spa therapy accessories or components such as AromaTherapy, ChromaTherapy, MusicTherapy, Steamlinx, and more </LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless-steel tank</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</LI><LI>60-minute electronic countdown shutdown with 75-minute limiting safety back-up</LI><LI>Electronic water-level control system and full-port drain valve</LI><LI>Built-in, low-voltage 24-volt control and ASME safety valve</LI></ul>",
			"tech": "Total Room Volume: 679 - 822<BR>KW: 24<BR>Wire Size*: 1<BR>Dimensions** : 27 ⅝” L x 20 ¾” H x 7 ⅞ ” D<BR>Water Usage Gallons***: 3.2<BR>Shipping Wt. (lbs)**** : 67<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR><BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/68f8ac0d-243e-4be3-ac85-561a12bb2993.pdf"
		},
		"images": {
			"thumbnail": "MX4E-6E.jpg",
			"folder": "generators/",
			"scene": "MS-Super-4-6.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 9
			},
			"zIndex": {
				"generators": 9
			},
			"series": "4-6"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": true
		}
	},
	{
		"code": "MX6EC1",
		"partnumber": "MX6E",
		"previewname": "MX6E",
		"name": "MX6E",
		"price": 7400,
		"descriptions": {
			"short": "Residential Generator",
			"long": "<BR>MAX Generators are built for large residential enclosures. These units are crafted from stainless steel and assembled with meticulous attention to detail. Every component is designed and engineered in-house to the most exacting standards.<ul><LI>Exclusive microprocessor operating system is the brains of our intelligent steam generator </LI><LI>All MrSteam residential steambath MAX Generators installed in the United States or Canada qualify for a limited lifetime warranty, for full warranty details visit: https://blog.mrsteam.com/wr</LI><LI>Industrial grade, large diameter copper heating element heats fast and is easy to remove and service</LI><LI>Modular Plug and Play connections for easy installation of spa therapy accessories or components such as AromaTherapy, ChromaTherapy, MusicTherapy, Steamlinx, and more </LI><LI>Naturally corrosion resistant, 100 percent recyclable stainless-steel tank</LI><LI>LED indicators to help you troubleshoot any connection and maintenance challenges</LI><LI>US and Canadian UL listed, and CE and NOM certified for unsurpassed quality and safety</LI><LI>60-minute electronic countdown shutdown with 75-minute limiting safety back-up</LI><LI>Electronic water-level control system and full-port drain valve</LI><LI>Built-in, low-voltage 24-volt control and ASME safety valve</LI></ul>",
			"tech": "Total Room Volume: 823 - 964<BR>KW: 30<BR>Wire Size*: 2/0<BR>Dimensions** : 27 ⅝” L x 20 ¾” H x 7 ⅞ ” D<BR>Water Usage Gallons***: 4<BR>Shipping Wt. (lbs)**** : 67<BR><BR><BR>*Wire size (AWG) based on minimum 90°C rated THHN copper conductors.<BR>Refer to the National Electrical Code for other types of conductors.<BR><BR>**Dimensions are for generator only, without AutoFlush or plumbing features.<BR><BR>***Water usage based on 20 minutes of operation.<BR><BR>****Shipping weight & pricing are for generator only, without control or steamhead.<BR><BR>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/68f8ac0d-243e-4be3-ac85-561a12bb2993.pdf"
		},
		"images": {
			"thumbnail": "MX4E-6E.jpg",
			"folder": "generators/",
			"scene": "MS-Super-4-6.png"
		},
		"taxonomy": {
			"categories": [
				"generators"
			],
			"sortOrder": {
				"generators": 10
			},
			"zIndex": {
				"generators": 10
			},
			"series": "4-6"
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 10,
					"width": 13,
					"height": 16
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false,
			"isSuperGenerator": true
		}
	},
	{
		"code": "ISTEAMX_CONTROL",
		"partnumber": "ISTEAMX_Control",
		"previewname": "ISTEAMX",
		"name": "iSteamX Touch Screen Control",
		"descriptions": {
			"short": "The iSteamX",
			"long": "With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This awardwinning control is the most technologically advanced steam shower control available.",
			"tech": "<li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian<li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/39ee6bd6-3ba2-45d1-a0bd-b4a97c25c527.pdf"
		},
		"images": {
			"thumbnail": "ISTEAMXBKPC.jpg",
			"folder": "individual-controls/iSteamX/",
			"scene": "mst2023-01_vspa_update_isteamx_PC_black.png"
		},
		"options": {
			"enabledListsIds": [
				"color"
			],
			"selected": {
				"color": "BLACK"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PC_black.png"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PC_white.png"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 50,
					"left": 69.5,
					"width": 4.5,
					"height": 6
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "XBUTLER_PACKAGE",
		"partnumber": "XBUTLER",
		"previewname": "xButler Package®",
		"name": "xButler Package®",
		"price": 3350,
		"descriptions": {
			"short": "The xButler package provides enhanced convenience and savings",
			"long": "With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This award-winning control is the most technologically advanced steam shower control available.",
			"tech": "<li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian</li><li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li>",
			"parts": "test"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/a3a9e7f5-a3ef-4f91-9eb6-e55f35aa8232.pdf"
		},
		"taxonomy": {
			"categories": [
				"isteamx-touch-screen-controls"
			]
		},
		"images": {
			"folder": "control-packages/xButler/",
			"thumbnail": "XBTLRBKPC.jpg",
			"scene": "ibutler_package_black.png"
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish",
				"steamHead"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME",
				"steamHead": "ISTEAM_STEAMHEAD"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				],
				"steamHead": [
					"ISTEAM_STEAMHEAD",
					"LINEAR_STEAMHEAD"
				]
			}
		},
		"dynamicProperties": {
			"price": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 4580
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 3530
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3450
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3780
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3980
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 4780
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3480
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3780
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKLPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKLBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKLBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKLOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKLPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKLPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKLSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKLMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHLPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHLBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHLBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHLOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHLPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHLPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHLSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHLMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKXPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKXBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKXBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKXOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKXPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKXPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKXSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKXMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHXPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHXBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHXBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHXOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHXPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHXPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHXSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHXMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKXLPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKXLBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKXLBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKXLOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKXLPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKXLPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKXLSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKXLMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHXLPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHXLBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHXLBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHXLOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHXLPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHXLPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHXLSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHXLMB.jpg"
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This awardwinning control is the most technologically advanced steam shower control available.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This awardwinning control is the most technologically advanced steam shower control available.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This awardwinning control is the most technologically advanced steam shower control available.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This awardwinning control is the most technologically advanced steam shower control available.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "The iButler MAX Linear Package, features the award-winning iSteamX Control and the award-winning Linear SteamHead. It includes the SteamLinx Module and Mobile App that enables Amazon Alexa Skills, 2 Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "The iButler MAX Linear Package, features the award-winning iSteamX Control and the award-winning Linear SteamHead. It includes the SteamLinx Module and Mobile App that enables Amazon Alexa Skills, 2 Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "The iButler MAX Linear Package, features the award-winning iSteamX Control and the award-winning Linear SteamHead. It includes the SteamLinx Module and Mobile App that enables Amazon Alexa Skills, 2 Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "The iButler MAX Linear Package, features the award-winning iSteamX Control and the award-winning Linear SteamHead. It includes the SteamLinx Module and Mobile App that enables Amazon Alexa Skills, 2 Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian</li><li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian</li><li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian</li><li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian</li><li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li> For MX4E - MX6E Generators </li><li> Includes the award-winning iSteamX Control with capcitive touch screen, programmable custom settings for up to with 8 users, 7 available languages, white or black interface color, real time clock, Autostart Programing to get your steam shower ready each day of the week</li><li>2 Aroma Glass SteamHeads that match MrSteam glass facia controls and features an oil reservoir discretely hidden at the top of the steam head</li><li> Control of your listening experience with AUX, Bluetooth, USB or Radio through your iSteamX Control</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through your iSteamX Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li> For MX4E - MX6E Generators </li><li> Includes the award-winning iSteamX Control with capcitive touch screen, programmable custom settings for up to with 8 users, 7 available languages, white or black interface color, real time clock, Autostart Programing to get your steam shower ready each day of the week</li><li>2 Aroma Glass SteamHeads that match MrSteam glass facia controls and features an oil reservoir discretely hidden at the top of the steam head</li><li> Control of your listening experience with AUX, Bluetooth, USB or Radio through your iSteamX Control</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through your iSteamX Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li> For MX4E - MX6E Generators </li><li> Includes the award-winning iSteamX Control with capcitive touch screen, programmable custom settings for up to with 8 users, 7 available languages, white or black interface color, real time clock, Autostart Programing to get your steam shower ready each day of the week</li><li>2 Aroma Glass SteamHeads that match MrSteam glass facia controls and features an oil reservoir discretely hidden at the top of the steam head</li><li> Control of your listening experience with AUX, Bluetooth, USB or Radio through your iSteamX Control</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through your iSteamX Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li> For MX4E - MX6E Generators </li><li> Includes the award-winning iSteamX Control with capcitive touch screen, programmable custom settings for up to with 8 users, 7 available languages, white or black interface color, real time clock, Autostart Programing to get your steam shower ready each day of the week</li><li>2 Aroma Glass SteamHeads that match MrSteam glass facia controls and features an oil reservoir discretely hidden at the top of the steam head</li><li> Control of your listening experience with AUX, Bluetooth, USB or Radio through your iSteamX Control</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through your iSteamX Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E</li></p>"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control </li><li>(1) AromaSteam SteamHead </li><li>(1) AutoFlush </li><li> (1) Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control </li><li>(1) AromaSteam SteamHead </li><li>(1) AutoFlush </li><li> (1) Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control </li><li>(1) Linear SteamHead </li><li>(1) AutoFlush </li><li> (1) Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control </li><li>(1) Linear SteamHead </li><li>(1) AutoFlush </li><li> (1) Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control in black </li><li>(2) AromaSteam Glass SteamHeads in black </li><li>(1) Max AutoFlush </li><li> (1) Max Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control in white </li><li>(2) AromaSteam Glass SteamHeads in white </li><li>(1) Max AutoFlush </li><li> (1) Max Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control in black </li><li> (2) 16 inch Linear SteamHeads </li><li>(1) Max AutoFlush </li><li> (1) Max Condensation Pan </li><li>(1) SteamLinx</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1)iSteamX Touch Screen Control in white </li><li> (2) 16 inch Linear SteamHeads </li><li>(1) Max AutoFlush </li><li> (1) Max Condensation Pan </li><li>(1) SteamLinx</li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKLPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKLBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKLBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKLOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKLPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKLPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKLSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKLMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHLPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHLBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHLBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHLOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHLPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHLPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHLSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHLMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKXPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKXBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKXBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKXOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKXPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKXPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKXSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKXMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHXPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHXBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHXBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHXOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHXPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHXPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHXSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHXMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRBKXLPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRBKXLBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRBKXLBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRBKXLOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRBKXLPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRBKXLPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRBKXLSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRBKXLMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XBTLRWHXLPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XBTLRWHXLBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XBTLRWHXLBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XBTLRWHXLOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XBTLRWHXLPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XBTLRWHXLPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XBTLRWHXLSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XBTLRWHXLMB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "ibutler_package_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "ibutler_package_2_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "ibutler_package_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "ibutler_package_2_white.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "ibutler_linear_package_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "ibutler_linear_package_2_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "ibutler_linear_package_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "ibutler_linear_package_2_white.png"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAM_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAM_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ISTEAMX_CONTROL",
						"quantity": 1
					},
					{
						"productId": "SteamLinx",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "ISTEAMX_PACKAGE",
		"partnumber": "ISTEAMX",
		"previewname": "ISTEAMX",
		"name": "iSteamX Shower Control",
		"price": 2300,
		"descriptions": {
			"short": "The iSteamX",
			"long": "With the iSteamX you have total control of every detail of your steaming experience. Housed in a sleek, slimline package, it mounts nearly flush on the wall of your shower. This awardwinning control is the most technologically advanced steam shower control available.",
			"tech": "<li>Change temperature & time settings with the touch of a finger</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Control of your listening experience with AUX, Bluetooth, USB or Radio</li><li>Create profiles for custom settings for temperature, time and more</li><li>Available in six different languages: English, French, Spanish, Italian, German, and Russian<li>Have peace of mind with temperature timed shut-offs and passcode protection</li><li>Automatically pre-heat your SteamShower so it's ready when you are</li><li>Water proof touch screen so technologically advanced it can tell the difference between a drop of water and your finger</li>"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/ec2bf67d-e707-4e3b-a9cc-1a3f94082b68.pdf"
		},
		"images": {
			"thumbnail": "ISTEAMXBKPC.jpg",
			"folder": "individual-controls/iSteamX/",
			"scene": "mst2023-01_vspa_update_isteamx_PC_black.png"
		},
		"taxonomy": {
			"categories": [
				"isteamx-touch-screen-controls"
			],
			"sortOrder": {
				"isteamx-touch-screen-controls": 1
			},
			"zIndex": {
				"isteamx-touch-screen-controls": 1
			}
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish"
			],
			"selected": {
				"color": "BLACK",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "ISTEAMXBKPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ISTEAMXBKBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ISTEAMXBKBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ISTEAMXBKOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "ISTEAMXBKPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "ISTEAMXBKPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "ISTEAMXBKSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "ISTEAMXBKMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "ISTEAMXWHPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ISTEAMXWHBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ISTEAMXWHBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ISTEAMXWHOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "ISTEAMXWHPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "ISTEAMXWHPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "ISTEAMXWHSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "ISTEAMXWHMB.jpg"
					}
				]
			},
			"links.tech": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/ec2bf67d-e707-4e3b-a9cc-1a3f94082b68.pdf"
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/ec2bf67d-e707-4e3b-a9cc-1a3f94082b68.pdf"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 2400
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							],
							[
								"BRUSHED_NICKEL"
							],
							[
								"OIL_RUBBED_BRONZE"
							],
							[
								"POLISHED_BRASS"
							],
							[
								"POLISHED_NICKEL"
							],
							[
								"SATIN_BRASS"
							],
							[
								"MATTE_BLACK"
							]
						],
						"value": 2500
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iSteamX Touch Screen Control</li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "ISTEAMXBKPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ISTEAMXBKBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ISTEAMXBKBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ISTEAMXBKOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "ISTEAMXBKPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "ISTEAMXBKPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "ISTEAMXBKSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "ISTEAMXBKMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "ISTEAMXWHPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ISTEAMXWHBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ISTEAMXWHBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ISTEAMXWHOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "ISTEAMXWHPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "ISTEAMXWHPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "ISTEAMXWHSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "ISTEAMXWHMB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PC_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_BB_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_BN_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_ORB_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PB_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PN_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_SB_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_MB_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PC_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_BB_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_BN_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_ORB_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PB_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_PN_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_SB_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "mst2023-01_vspa_update_isteamx_MB_white.png"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAMX_CONTROL",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAMX_CONTROL",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ISTEAMX_CONTROL",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "color",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "ISTEAM_STEAMHEAD",
		"partnumber": "ISTEAM3.0 ISTEAMHEAD",
		"previewname": "iSteam SteamHead",
		"name": "iSteam SteamHead",
		"descriptions": {
			"long": "We're passionate about steam, so we invest in every detail of our steam shower products. All of our steamheads leave a lasting visual imprint in any shower space. They provide a steam dispersion that has no moving parts, require no field assembly, and simple installation that matches any interior. Each of our steamhead designs will transform your shower giving you the atmosphere you desire-making steam second nature to your wellbeing.</LI>",
			"tech": "<li>Features oil reservoir for aroma therapy</li><li>Sleek black or white glass face complements the look of our glass face controls. It comes standard with glass face controls</li><li>No assembly of moving parts required</li><li>Standard with glass finish controls</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/c48bdca4-da11-43ca-9a63-73a5bb12bf28.pdf"
		},
		"images": {
			"thumbnail": "isteam_steamhead.jpg",
			"folder": "individual-controls/iSteam/",
			"scene": "iSteam-SteamHead-Black.png"
		},
		"options": {
			"enabledListsIds": [
				"color"
			],
			"selected": {
				"color": "BLACK"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								null
							],
							[
								"BLACK",
								"MS90EC1"
							],
							[
								"BLACK",
								"MS150EC1"
							],
							[
								"BLACK",
								"MS225EC1"
							],
							[
								"BLACK",
								"MS400EC1"
							],
							[
								"BLACK",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"MSSUPER3EC1"
							]
						],
						"value": "iSteam-SteamHead-Black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"MX4EC1"
							],
							[
								"BLACK",
								"MX5EC1"
							],
							[
								"BLACK",
								"MX6EC1"
							]
						],
						"value": "iSteam-SteamHead-Black-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								null
							],
							[
								"WHITE",
								"MS90EC1"
							],
							[
								"WHITE",
								"MS150EC1"
							],
							[
								"WHITE",
								"MS225EC1"
							],
							[
								"WHITE",
								"MS400EC1"
							],
							[
								"WHITE",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"MSSUPER3EC1"
							]
						],
						"value": "iSteam-SteamHead-White.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"MX4EC1"
							],
							[
								"WHITE",
								"MX5EC1"
							],
							[
								"WHITE",
								"MX6EC1"
							]
						],
						"value": "iSteam-SteamHead-White-Double.png"
					}
				]
			},
			"tooltips.list": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"top": 72.5,
								"left": 40,
								"width": 3,
								"height": 4
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"top": 71.5,
								"left": 43.7,
								"width": 3,
								"height": 4,
								"orientation": "right"
							},
							{
								"top": 73.2,
								"left": 36.5,
								"width": 3,
								"height": 4,
								"orientation": "left"
							}
						]
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 72.5,
					"left": 40,
					"width": 3,
					"height": 4
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": true
		}
	},
	{
		"code": "AIRTEMPO_PACKAGE",
		"partnumber": "AIRT",
		"previewname": "AirTempo Wireless Steam Shower Control",
		"name": "AirTempo Wireless Steam Shower Control",
		"price": 1550,
		"descriptions": {
			"short": "AirTempo Surface Mount Programmable Control – Wireless",
			"long": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat.",
			"tech": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li><li>LCD display</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/6805c486-7ad2-47aa-b292-83cc7a6980a9.pdf"
		},
		"images": {
			"thumbnail": "AIRTBK-PC.jpg",
			"folder": "individual-controls/AirTempo/"
		},
		"taxonomy": {
			"categories": [
				"airtempo-wireless-controls"
			],
			"sortOrder": {
				"airtempo-wireless-controls": 2
			},
			"zIndex": {
				"airtempo-wireless-controls": 2
			}
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish"
			],
			"selected": {
				"color": "BLACK",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "AIRTBK-PC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "AIRTBK-BB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "AIRTBK-BN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "AIRTBK-ORB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "AIRTBK-PB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "AIRTBK-PN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "AIRTBK-SB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "AIRTBK-MB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "AIRTWH-PC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "AIRTWH-BB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "AIRTWH-BN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "AIRTWH-ORB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "AIRTWH-PB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "AIRTWH-PN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "AIRTWH-SB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "AIRTWH-MB.jpg"
					}
				]
			},
			"links.tech": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": "http://prodrep.mrsteam.com/DocumentResources/5ec25c10-e17d-434b-a820-3c5753948cca.pdf"
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "http://prodrep.mrsteam.com/DocumentResources/5ec25c10-e17d-434b-a820-3c5753948cca.pdf"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 1700
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							],
							[
								"BRUSHED_NICKEL"
							],
							[
								"OIL_RUBBED_BRONZE"
							],
							[
								"POLISHED_BRASS"
							],
							[
								"POLISHED_NICKEL"
							],
							[
								"SATIN_BRASS"
							],
							[
								"MATTE_BLACK"
							]
						],
						"value": 1900
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo Wireless Steam Shower Control</li><li>AirTempo SteamHead</li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "AIRTBK-PC"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "AIRTBK-BB"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "AIRTBK-BN"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "AIRTBK-ORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "AIRTBK-PB"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "AIRTBK-PN"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "AIRTBK-SB"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "AIRTBK-MB"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "AIRTWH-PC"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "AIRTWH-BB"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "AIRTWH-BN"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "AIRTWH-ORB"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "AIRTWH-PB"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "AIRTWH-PN"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "AIRTWH-SB"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "AIRTWH-MB"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "AIRTEMPO_STEAMHEAD",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "AIRTEMPO_STEAMHEAD",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "AIRTEMPO_CONTROL",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "color",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "AIRTEMPO_CONTROL",
		"partnumber": "AIRT CONTROL",
		"previewname": "AirTempo Wireless Steam Shower Control",
		"name": "AirTempo Wireless Steam Shower Control",
		"descriptions": {
			"short": "AirTempo Surface Mount Programmable Control – Wireless",
			"long": "Wireless. No longer tethered by cables, the AirTempo control offers a nomadic way to control your steam. Its exquisite waterproof design, allows the AirTempo control to be easily installed on almost any steam room wall, even glass. \\r\\n",
			"tech": "<li>Need to replace or upgrade your control? Do so easily with the new wireless AirTempo</li>\\r\\n<li>Includes two CR2450 lithium batteries</li>\\r\\n<li>A six month battery life if used daily for 20 minutes </li>\\r\\n<li>Programmable Temperature and time, AromaSteam, ChromaSteam, Dual Settings</li>\\r\\n<li>Comes standard as surface mount with available flush mount options </li>\\r\\n<li>60 foot wireless range from steam generator </li><li>LCD display</li>"
		},
		"images": {
			"thumbnail": "AirTempo-Package-Black-PolishedChrome.jpg",
			"folder": "individual-controls/AirTempo/",
			"scene": "AirTempo-SteamHead-Black.png"
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish"
			],
			"selected": {
				"color": "BLACK",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME"
							]
						],
						"value": "AirTempo-Control-Black-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE"
							]
						],
						"value": "AirTempo-Control-Black-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL"
							]
						],
						"value": "AirTempo-Control-Black-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "AirTempo-Control-Black-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS"
							]
						],
						"value": "AirTempo-Control-Black-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL"
							]
						],
						"value": "AirTempo-Control-Black-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS"
							]
						],
						"value": "AirTempo-Control-Black-SatinBrass.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"MATTE_BLACK"
							]
						],
						"value": "AirTempo-Control-Black-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME"
							]
						],
						"value": "AirTempo-Control-White-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "AirTempo-Control-White-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "AirTempo-Control-White-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "AirTempo-Control-White-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS"
							]
						],
						"value": "AirTempo-Control-White-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL"
							]
						],
						"value": "AirTempo-Control-White-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS"
							]
						],
						"value": "AirTempo-Control-White-SatinBrass.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"MATTE_BLACK"
							]
						],
						"value": "AirTempo-Control-White-OilRubbedBronze.png"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 50,
					"left": 69.5,
					"width": 4.5,
					"height": 6
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "AIRTEMPO_STEAMHEAD",
		"partnumber": "AIRT STEAMHEAD",
		"previewname": "AirTempo SteamHead",
		"name": "AirTempo SteamHead",
		"descriptions": {
			"long": "We're passionate about steam, so we invest in every detail of our steam shower products. All of our steamheads leave a lasting visual imprint in any shower space. They provide a steam dispersion that has no moving parts, require no field assembly, and simple installation that matches any interior. Each of our steamhead designs will transform your shower giving you the atmosphere you desire-making steam second nature to your wellbeing.</LI>",
			"tech": "<li>Features oil reservoir for aroma therapy</li><li>Sleek black or white glass face complements the look of our glass face controls. It comes standard with glass face controls</li><li>No assembly of moving parts required</li><li>Standard with glass finish controls</li><li>Available in 7 metal trim finishes to match your control selection</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/c48bdca4-da11-43ca-9a63-73a5bb12bf28.pdf"
		},
		"images": {
			"thumbnail": "airtempo_steamhead.jpg",
			"folder": "individual-controls/AirTempo/",
			"scene": "AirTempo-SteamHead-Black.png"
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish"
			],
			"selected": {
				"color": "BLACK",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.finish",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME",
								null
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MS90EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MS150EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MS225EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MS400EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE",
								null
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MS90EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MS150EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MS225EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MS400EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL",
								null
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MS90EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MS150EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MS225EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MS400EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								null
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MS90EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MS150EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MS225EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MS400EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS",
								null
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MS90EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MS150EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MS225EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MS400EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL",
								null
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MS90EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MS150EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MS225EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MS400EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS",
								null
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MS90EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MS150EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MS225EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MS400EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-SatinBrass.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME",
								null
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MS90EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MS150EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MS225EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MS400EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE",
								null
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MS90EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MS150EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MS225EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MS400EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL",
								null
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MS90EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MS150EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MS225EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MS400EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								null
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MS90EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MS150EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MS225EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MS400EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS",
								null
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MS90EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MS150EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MS225EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MS400EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL",
								null
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MS90EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MS150EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MS225EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MS400EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS",
								null
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MS90EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MS150EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MS225EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MS400EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-SatinBrass.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_CHROME",
								"MX4EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MX5EC1"
							],
							[
								"BLACK",
								"POLISHED_CHROME",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MX4EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MX5EC1"
							],
							[
								"BLACK",
								"BRUSHED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-BrushedBronze-Double.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MX4EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MX5EC1"
							],
							[
								"BLACK",
								"BRUSHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-BrushedNickel-Double.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MX4EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MX5EC1"
							],
							[
								"BLACK",
								"OIL_RUBBED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-OilRubbedBronze-Double.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_BRASS",
								"MX4EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MX5EC1"
							],
							[
								"BLACK",
								"POLISHED_BRASS",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-PolishedBrass-Double.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MX4EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MX5EC1"
							],
							[
								"BLACK",
								"POLISHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-PolishedNickel-Double.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"SATIN_BRASS",
								"MX4EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MX5EC1"
							],
							[
								"BLACK",
								"SATIN_BRASS",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-Black-SatinBrass-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_CHROME",
								"MX4EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MX5EC1"
							],
							[
								"WHITE",
								"POLISHED_CHROME",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MX4EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MX5EC1"
							],
							[
								"WHITE",
								"BRUSHED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-BrushedBronze-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MX4EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MX5EC1"
							],
							[
								"WHITE",
								"BRUSHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-BrushedNickel-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MX4EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MX5EC1"
							],
							[
								"WHITE",
								"OIL_RUBBED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-OilRubbedBronze-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_BRASS",
								"MX4EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MX5EC1"
							],
							[
								"WHITE",
								"POLISHED_BRASS",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-PolishedBrass-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MX4EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MX5EC1"
							],
							[
								"WHITE",
								"POLISHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-PolishedNickel-Double.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"SATIN_BRASS",
								"MX4EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MX5EC1"
							],
							[
								"WHITE",
								"SATIN_BRASS",
								"MX6EC1"
							]
						],
						"value": "AirTempo-SteamHead-White-SatinBrass-Double.png"
					}
				]
			},
			"tooltips.list": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"top": 72.5,
								"left": 40,
								"width": 3,
								"height": 4
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"top": 71.5,
								"left": 43.7,
								"width": 3,
								"height": 4,
								"orientation": "right"
							},
							{
								"top": 73.2,
								"left": 36.5,
								"width": 3,
								"height": 4,
								"orientation": "left"
							}
						]
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 72.5,
					"left": 40,
					"width": 3,
					"height": 4
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": true
		}
	},
	{
		"code": "ITEMPO_PLUS_PACKAGE",
		"partnumber": "MSITPLUS",
		"previewname": "iTempo Plus Control",
		"name": "iTempo Plus Control",
		"price": 1350,
		"descriptions": {
			"long": "Its never been easier to optimize your steam shower experience. With an elegant design and easy to use interface, you can control more than steam. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center.",
			"tech": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaSteam lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li><li>Operates with optional SteamLinx™</li><li>Control includes digital clock</li>",
			"parts": "test"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/b759ed5f-4528-45f1-b6f1-e22967c9f281.pdf"
		},
		"images": {
			"thumbnail": "MSITPLUSSQ-PC.jpg",
			"folder": "individual-controls/iTempoPlus/"
		},
		"taxonomy": {
			"categories": [
				"itempo-plus-controls"
			],
			"sortOrder": {
				"itempo-plus-controls": 2
			},
			"zIndex": {
				"itempo-plus-controls": 2
			}
		},
		"options": {
			"enabledListsIds": [
				"shape",
				"finish"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"shape": [
					"SQUARE",
					"ROUND"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"BLACK",
					"MATTE_BLACK",
					"WHITE",
					"RAW"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "MSITPLUSRD-BK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "MSITPLUSRD-MB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "MSITPLUSRD-WH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITPLUSRD-PC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITPLUSRD-BB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITPLUSRD-BN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITPLUSRD-ORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITPLUSRD-PB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITPLUSRD-PN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "MSITPLUSRD-SB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"Raw"
							]
						],
						"value": "MSITPLUSRD-RAW.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "MSITPLUSSQ-BK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "MSITPLUSSQ-MB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "MSITPLUSSQ-WH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITPLUSSQ-PC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITPLUSSQ-BB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITPLUSSQ-BN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITPLUSSQ-ORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITPLUSSQ-PB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITPLUSSQ-PN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "MSITPLUSSQ-SB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW"
							]
						],
						"value": "MSITPLUSSQ-RAW.jpg"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>iTempo SteamHead</li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "MSITPLUSRD-BK"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "MSITPLUSRD-MB"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "MSITPLUSRD-WH"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITPLUSRD-PC"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITPLUSRD-BB"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITPLUSRD-BN"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITPLUSRD-ORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITPLUSRD-PB"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITPLUSRD-PN"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "MSITPLUSRD-SB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "MSITPLUSSQ-BK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "MSITPLUSSQ-MB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "MSITPLUSSQ-WH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITPLUSSQ-PC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITPLUSSQ-BB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITPLUSSQ-BN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITPLUSSQ-ORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITPLUSSQ-PB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITPLUSSQ-PN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "MSITPLUSSQ-SB"
					}
				]
			},
			"links.tech": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": "http://prodrep.mrsteam.com/DocumentResources/b759ed5f-4528-45f1-b6f1-e22967c9f281.pdf"
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "http://prodrep.mrsteam.com/DocumentResources/b759ed5f-4528-45f1-b6f1-e22967c9f281.pdf"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 1450
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							],
							[
								"BRUSHED_NICKEL"
							],
							[
								"OIL_RUBBED_BRONZE"
							],
							[
								"POLISHED_BRASS"
							],
							[
								"POLISHED_NICKEL"
							],
							[
								"SATIN_BRASS"
							],
							[
								"WHITE"
							],
							[
								"MATTE_BLACK"
							],
							[
								"BLACK"
							],
							[
								"RAW"
							]
						],
						"value": 1600
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "ITEMPO_STEAMHEAD",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ITEMPO_STEAMHEAD",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ITEMPO_CONTROL",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "ITEMPO_CONTROL",
		"partnumber": "MSITEMPO",
		"name": "iTempo Plus Control",
		"previewname": "iTempo Plus Control",
		"descriptions": {
			"long": "With the flush-moutned iTempoPlus Control, your steam system can be seamless. Command more than just steam on this user-friendly interface. Easily add AromaSteam and ChromaSteam capabilities from this sleek control. It has never been easier to optimize your steam shower experience.",
			"tech": "<li>Comes with matching Aroma Designer Finish Steamhead</li><li>Display lets you program temperature and get comfortable</li><li>Easily mount and install your control snug to the wall</li><li>Operates with optional wireless SteamLinx Module</li><li>Use your smartphone or mobile device to control your steam shower</li><li>Works with Steamlinx module and mobile app</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/b2810ea7-b57e-409a-ad8a-f542851f66be.pdf"
		},
		"images": {
			"thumbnail": "MSITEMPOSQ-PC.jpg",
			"folder": "individual-controls/iTempo/",
			"scene": "iTempo-Control-Square.png"
		},
		"options": {
			"enabledListsIds": [
				"shape",
				"finish"
			],
			"selected": {
				"shape": "SQUARE",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"shape": [
					"SQUARE",
					"ROUND"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK",
					"BLACK",
					"WHITE",
					"RAW"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "iTempo-Control-Round-Black.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "iTempo-Control-Round-Black.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "iTempo-Control-Round-White.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "iTempo-Control-Round-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "iTempo-Control-Round-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "iTempo-Control-Round-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "iTempo-Control-Round-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "iTempo-Control-Round-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "iTempo-Control-Round-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "iTempo-Control-Round-SatinBrass.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW"
							]
						],
						"value": "iTempo-Control-Round-SatinBrass.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "iTempo-Control-Square-Black.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "iTempo-Control-Square-Black.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "iTempo-Control-Square-White.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "iTempo-Control-Square-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "iTempo-Control-Square-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "iTempo-Control-Square-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "iTempo-Control-Square-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "iTempo-Control-Square-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "iTempo-Control-Square-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "iTempo-Control-Square-SatinBrass.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW"
							]
						],
						"value": "iTempo-Control-Square-SatinBrass.png"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 50,
					"left": 69.5,
					"width": 4.5,
					"height": 6
				}
			]
		}
	},
	{
		"code": "ITEMPO_STEAMHEAD",
		"partnumber": "MSITEMPO STEAMHEAD",
		"previewname": "iTempo SteamHead",
		"name": "iTempo SteamHead",
		"descriptions": {
			"long": "We're passionate about steam, so we invest in every detail of our steam shower products. All of our steamheads leave a lasting visual imprint in any shower space. They provide a steam dispersion that has no moving parts, require no field assembly, and simple installation that matches any interior. Each of our steamhead designs will transform your shower giving you the atmosphere you desire-making steam second nature to your wellbeing.</LI>",
			"tech": "<li>Features oil reservoir for aroma therapy</li><li>Sleek black or white glass face complements the look of our glass face controls. It comes standard with glass face controls</li><li>No assembly of moving parts required</li><li>Standard with glass finish controls</li><li>Available in 7 metal trim finishes to match your control selection</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/c48bdca4-da11-43ca-9a63-73a5bb12bf28.pdf"
		},
		"images": {
			"thumbnail": "itempo_steamhead.jpg",
			"folder": "individual-controls/iTempo/",
			"scene": "iTempo-SteamHead-Black.png"
		},
		"options": {
			"enabledListsIds": [
				"shape",
				"finish"
			],
			"selected": {
				"shape": "SQUARE",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"shape": [
					"SQUARE",
					"ROUND"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"BLACK",
					"MATTE_BLACK",
					"WHITE",
					"RAW"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"BLACK",
								null
							],
							[
								"SQUARE",
								"BLACK",
								"MS90EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MS150EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MS225EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MS400EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-Black.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK",
								null
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MS90EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MS150EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MS225EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MS400EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-Black.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE",
								null
							],
							[
								"SQUARE",
								"WHITE",
								"MS90EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MS150EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MS225EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MS400EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-White.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME",
								null
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MS90EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MS150EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MS225EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MS400EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								null
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MS90EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MS150EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MS225EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MS400EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								null
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MS90EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MS150EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MS225EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MS400EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								null
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MS90EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MS150EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MS225EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MS400EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS",
								null
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MS90EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MS150EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MS225EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MS400EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL",
								null
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MS90EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MS150EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MS225EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MS400EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS",
								null
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MS90EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MS150EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MS225EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MS400EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-SatinBrass.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW",
								null
							],
							[
								"SQUARE",
								"RAW",
								"MS90EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MS150EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MS225EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MS400EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MSSUPER1EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MSSUPER2EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-SatinBrass.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BLACK",
								null
							],
							[
								"ROUND",
								"BLACK",
								"MS90EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MS150EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MS225EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MS400EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK",
								null
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MS90EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MS150EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MS225EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MS400EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE",
								null
							],
							[
								"ROUND",
								"WHITE",
								"MS90EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MS150EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MS225EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MS400EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME",
								null
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MS90EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MS150EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MS225EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MS400EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE",
								null
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MS90EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MS150EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MS225EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MS400EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-BrushedBronze.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL",
								null
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MS90EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MS150EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MS225EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MS400EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								null
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MS90EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MS150EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MS225EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MS400EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS",
								null
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MS90EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MS150EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MS225EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MS400EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedBrass.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL",
								null
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MS90EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MS150EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MS225EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MS400EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS",
								null
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MS90EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MS150EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MS225EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MS400EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-SatinBrass.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW",
								null
							],
							[
								"ROUND",
								"RAW",
								"MS90EC1"
							],
							[
								"ROUND",
								"RAW",
								"MS150EC1"
							],
							[
								"ROUND",
								"RAW",
								"MS225EC1"
							],
							[
								"ROUND",
								"RAW",
								"MS400EC1"
							],
							[
								"ROUND",
								"RAW",
								"MSSUPER1EC1"
							],
							[
								"ROUND",
								"RAW",
								"MSSUPER2EC1"
							],
							[
								"ROUND",
								"RAW",
								"MSSUPER3EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-SatinBrass.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK",
								"MX4EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MX5EC1"
							],
							[
								"SQUARE",
								"BLACK",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-Black-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK",
								"MX4EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MX5EC1"
							],
							[
								"SQUARE",
								"MATTE_BLACK",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-Black-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE",
								"MX4EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MX5EC1"
							],
							[
								"SQUARE",
								"WHITE",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-White-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MX4EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MX5EC1"
							],
							[
								"SQUARE",
								"POLISHED_CHROME",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MX4EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MX5EC1"
							],
							[
								"SQUARE",
								"BRUSHED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-BrushedBronze-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MX4EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MX5EC1"
							],
							[
								"SQUARE",
								"BRUSHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-BrushedNickel-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MX4EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MX5EC1"
							],
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-OilRubbedBronze-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MX4EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MX5EC1"
							],
							[
								"SQUARE",
								"POLISHED_BRASS",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-PolishedBrass-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MX4EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MX5EC1"
							],
							[
								"SQUARE",
								"POLISHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-PolishedNickel-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS",
								"MX4EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MX5EC1"
							],
							[
								"SQUARE",
								"SATIN_BRASS",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-SatinBrass-Double.png"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW",
								"MX4EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MX5EC1"
							],
							[
								"SQUARE",
								"RAW",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Square-SatinBrass-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE",
								"MX4EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MX5EC1"
							],
							[
								"ROUND",
								"WHITE",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BLACK",
								"MX4EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MX5EC1"
							],
							[
								"ROUND",
								"BLACK",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK",
								"MX4EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MX5EC1"
							],
							[
								"ROUND",
								"MATTE_BLACK",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME",
								"MX4EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MX5EC1"
							],
							[
								"ROUND",
								"POLISHED_CHROME",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedChrome-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MX4EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MX5EC1"
							],
							[
								"ROUND",
								"BRUSHED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-BrushedBronze-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MX4EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MX5EC1"
							],
							[
								"ROUND",
								"BRUSHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-BrushedNickel-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MX4EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MX5EC1"
							],
							[
								"ROUND",
								"OIL_RUBBED_BRONZE",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-OilRubbedBronze-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS",
								"MX4EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MX5EC1"
							],
							[
								"ROUND",
								"POLISHED_BRASS",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedBrass-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MX4EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MX5EC1"
							],
							[
								"ROUND",
								"POLISHED_NICKEL",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-PolishedNickel-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS",
								"MX4EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MX5EC1"
							],
							[
								"ROUND",
								"SATIN_BRASS",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-SatinBrass-Double.png"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW",
								"MX4EC1"
							],
							[
								"ROUND",
								"RAW",
								"MX5EC1"
							],
							[
								"ROUND",
								"RAW",
								"MX6EC1"
							]
						],
						"value": "iTempo-SteamHead-Round-SatinBrass-Double.png"
					}
				]
			},
			"tooltips.list": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"top": 72.5,
								"left": 40,
								"width": 3,
								"height": 4
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"top": 72.5,
								"left": 43.7,
								"width": 3,
								"height": 4,
								"orientation": "right"
							},
							{
								"top": 74.5,
								"left": 36.5,
								"width": 3,
								"height": 4,
								"orientation": "left"
							}
						]
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 72.5,
					"left": 40,
					"width": 3,
					"height": 4
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "ITEMPO_PACKAGE",
		"partnumber": "MSITEMPO",
		"previewname": "iTempo Control",
		"name": "iTempo Control",
		"price": 895,
		"descriptions": {
			"long": "The iTempo Control is simple, elegant, and easy to use. Forged from solid brass and available in your choice of 10 designer finishes, iTempo meshes seamlessly with any bathroom décor.",
			"tech": "<li>Easily mount and install your control snug to the wall</li><li>Use your smartphone or mobile device to control your steam shower</li><li>Whatever your preference, program your temperature and get comfortable</li><li>Operates with optional wireless SteamLinx™ Control</li>",
			"parts": "test"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/b2810ea7-b57e-409a-ad8a-f542851f66be.pdf"
		},
		"images": {
			"thumbnail": "MSITEMPOSQ-PC.jpg",
			"folder": "individual-controls/iTempo/"
		},
		"taxonomy": {
			"categories": [
				"itempo-controls"
			],
			"sortOrder": {
				"itempo-controls": 2
			},
			"zIndex": {
				"itempo-controls": 2
			}
		},
		"options": {
			"enabledListsIds": [
				"shape",
				"finish"
			],
			"selected": {
				"color": "BLACK",
				"shape": "SQUARE",
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"shape": [
					"SQUARE",
					"ROUND"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"BLACK",
					"MATTE_BLACK",
					"WHITE",
					"RAW"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "MSITEMPORD-BK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "MSITEMPORD-MB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "MSITEMPORD-WH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITEMPORD-PC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITEMPORD-BB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITEMPORD-BN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITEMPORD-ORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITEMPORD-PB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITEMPORD-PN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "MSITEMPORD-SB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW"
							]
						],
						"value": "MSITEMPORD-RAW.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "MSITEMPOSQ-BK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "MSITEMPOSQ-MB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "MSITEMPOSQ-WH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITEMPOSQ-PC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITEMPOSQ-BB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITEMPOSQ-BN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITEMPOSQ-ORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITEMPOSQ-PB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITEMPOSQ-PC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "MSITEMPOSQ-SB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW"
							]
						],
						"value": "MSITEMPOSQ-RAW.jpg"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW"
							]
						],
						"value": "<li>iTempo Control</li><li>iTempo SteamHead</li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"ROUND",
								"BLACK"
							]
						],
						"value": "MSITEMPORD-BK"
					},
					{
						"tally": [
							[
								"ROUND",
								"MATTE_BLACK"
							]
						],
						"value": "MSITEMPORD-MB"
					},
					{
						"tally": [
							[
								"ROUND",
								"WHITE"
							]
						],
						"value": "MSITEMPORD-WH"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITEMPORD-PC"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITEMPORD-BB"
					},
					{
						"tally": [
							[
								"ROUND",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITEMPORD-BN"
					},
					{
						"tally": [
							[
								"ROUND",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITEMPORD-ORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITEMPORD-PB"
					},
					{
						"tally": [
							[
								"ROUND",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITEMPORD-PN"
					},
					{
						"tally": [
							[
								"ROUND",
								"SATIN_BRASS"
							]
						],
						"value": "MSITEMPORD-SB"
					},
					{
						"tally": [
							[
								"ROUND",
								"RAW"
							]
						],
						"value": "MSITEMPORD-RAW"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BLACK"
							]
						],
						"value": "MSITEMPOSQ-BK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"MATTE_BLACK"
							]
						],
						"value": "MSITEMPOSQ-MB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"WHITE"
							]
						],
						"value": "MSITEMPOSQ-WH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_CHROME"
							]
						],
						"value": "MSITEMPOSQ-PC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSITEMPOSQ-BB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSITEMPOSQ-BN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSITEMPOSQ-ORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_BRASS"
							]
						],
						"value": "MSITEMPOSQ-PB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSITEMPOSQ-PN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"SATIN_BRASS"
							]
						],
						"value": "MSITEMPOSQ-SB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"RAW"
							]
						],
						"value": "MSITEMPOSQ-RAW"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 950
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"POLISHED_BRASS"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": 1150
					},
					{
						"tally": [
							[
								"RAW"
							]
						],
						"value": 1150
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ITEMPO_CONTROL",
						"quantity": 1
					},
					{
						"productId": "ITEMPO_STEAMHEAD",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "AUTOFLUSH",
		"partnumber": "MS81500E",
		"previewname": "AutoFlush",
		"name": "AutoFlush",
		"price": 515,
		"descriptions": {
			"short": "Autoflush for residential MS generators",
			"long": "Your steam generator is the most important component of your steam shower. Protect your investment with AutoFlush. AutoFlush® is a MrSteam exclusive product. It's an automatic self-cleaning system that promotes a long, healthy life for steam generators by automatically flushing the generator of sediment two hours after every steambath. We automate everything in the background, so no work is needed after every steam shower session. AutoFlush® assures that you get clean steam every time.",
			"tech": "<li>The system quietly flushes impurities through a ½\" electronically-activated valve - no small opening to clog</li><li>Automatically flushes old water and impurities from your steam generator after every session, no buttons to push to initiate draining</li><li>Impurities and old water are flushed through a ½\", electronically activated valve. You'll never experience a clog, and there's nothing to remember</li><li>Simple plug and play installation</li><li>Length-4.25\"</li><li>Width-5\"</li><li>Height-2.75\"</li><li>Weight-2 lbs</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/7abd8ed4-8769-4dc7-baff-af9afcfeceea.pdf"
		},
		"images": {
			"thumbnail": "AutoFlush.jpg",
			"folder": "controls-accessories/",
			"scene": "AutoFlush.png"
		},
		"taxonomy": {
			"categories": [
				"controls-accessories"
			],
			"sortOrder": {
				"controls-accessories": 3
			},
			"zIndex": {
				"controls-accessories": 3
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "AutoFlush.jpg"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "autoflushmax.jpg"
					}
				]
			},
			"descriptions.short": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "Autoflush for residential MS generators"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "Max AutoFlush for Residential eSeries Max Generators"
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "Your steam generator is the most important component of your steam shower. Protect your investment with AutoFlush. AutoFlush® is a MrSteam exclusive product. It's an automatic self-cleaning system that promotes a long, healthy life for steam generators by automatically flushing the generator of sediment two hours after every steambath. We automate everything in the background, so no work is needed after every steam shower session. AutoFlush® assures that you get clean steam every time."
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "Your steam generator is the most important component of your steam shower. Protect your investment with AutoFlush. AutoFlush® is a MrSteam exclusive product. It's an automatic self-cleaning system that promotes a long, healthy life for steam generators by automatically flushing the generator of sediment two hours after every steambath. We automate everything in the background, so no work is needed after every steam shower session. AutoFlush® assures that you get clean steam every time."
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "<li>The system quietly flushes impurities through a ½\" electronically-activated valve - no small opening to clog</li><li>Automatically flushes old water and impurities from your steam generator after every session, no buttons to push to initiate draining</li><li>Impurities and old water are flushed through a ½\", electronically activated valve. You'll never experience a clog, and there's nothing to remember</li><li>Simple plug and play installation</li><li>Length-4.25\"</li><li>Width-5\"</li><li>Height-2.75\"</li><li>Weight-2 lbs</li>"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "<li>The system quietly flushes impurities through a ½\" electronically-activated valve - no small opening to clog</li><li>Automatically flushes old water and impurities from your steam generator after every session, no buttons to push to initiate draining</li><li>Impurities and old water are flushed through a ½\", electronically activated valve. You'll never experience a clog, and there's nothing to remember</li><li>Simple plug and play installation</li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "MS81500E"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "CT81500"
					}
				]
			},
			"name": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "AutoFlush"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "AutoFlush Max"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": 550
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": 580
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": "AutoFlush-MS-90-400.png"
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "AutoFlush-MS-Super-1-3.png"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "AutoFlush-MS-Super-4-6.png"
					}
				]
			},
			"tooltips.list": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"top": 79.5,
								"left": 20,
								"width": 3,
								"height": 6,
								"orientation": "right"
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"top": 80,
								"left": 22,
								"width": 3,
								"height": 6,
								"orientation": "right"
							}
						]
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"top": 78.5,
								"left": 22,
								"width": 4,
								"height": 7,
								"orientation": "right"
							}
						]
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 79.5,
					"left": 20,
					"width": 3,
					"height": 6,
					"orientation": "right"
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "Condensation Pan",
		"partnumber": "103867",
		"previewname": "Condensation Pan",
		"name": "Condensation Pan",
		"price": 185,
		"descriptions": {
			"long": "Sitting under our e-Series Generators, the Condensation Pan protects bathrooms from potential water escape. Just locate the condensation pan on a solid level surface and place the steam generator inside the condensation pan. Insure the steam generator is level. Condensation pan drains by gravity.",
			"tech": "<li>Installs beneath the steam generator and connects to an approved drain line to collect and direct a potential water accumulation or leak</li>\\r\\n<li>Built in brackets raise the Steam Generator above the bottom of the pan</li>\\r\\n<li>Measures 25”L x 9”W x 1  ½”H\" NPT fitting</li><li>Compatible with all Mr. Steam generators</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/c566466a-4819-4364-b47b-9ec1e71d3f77.pdf"
		},
		"images": {
			"thumbnail": "condensationpan.jpg",
			"folder": "controls-accessories/",
			"scene": "DripPan.png"
		},
		"taxonomy": {
			"categories": [
				"controls-accessories"
			],
			"sortOrder": {
				"controls-accessories": 4
			},
			"zIndex": {
				"controls-accessories": 4
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "condensationpan.jpg"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "maxcondpan.jpg"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": 195
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": 275
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": 103867
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": 104402
					}
				]
			},
			"name": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "Condensation Pan"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "Max Condensation Pan"
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "Sitting under our e-Series Generators, the Condensation Pan protects bathrooms from potential water escape. Just locate the condensation pan on a solid level surface and place the steam generator inside the condensation pan. Insure the steam generator is level. Condensation pan drains by gravity."
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "Sitting under our MAX Series Generators, the MAX Condensation Pan protects bathrooms from potential water escape. Just locate the condensation pan on a solid level surface and place the steam generator inside the condensation pan. Insure the steam generator is level. MAX Condensation pan drains by gravity."
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							],
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "<li>Installs beneath the steam generator and connects to an approved drain line to collect and direct a potential water accumulation or leak</li>\\r\\n<li>Built in brackets raise the Steam Generator above the bottom of the pan</li>\\r\\n<li>Measures 25”L x 9”W x 1  ½”H\" NPT fitting</li><li>Compatible with all Mr. Steam generators</li>"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "<li>For MX4E - MX6E Generators</li><li>Installs beneath the MAX Steam Generator and connects to an approved drain line to collect and direct a potential water accumulation or leak</li><li>Built in brackets raise the MAX Steam Generator above the bottom of the pan</li><li>Measures 33” x 9” x 1 1/2”</li>"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": "DripPan-MS-90-400.png"
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": "DripPan-MS-Super-1-3.png"
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": "drippanmax.png"
					}
				]
			},
			"tooltips.list": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"top": 84,
								"left": 8,
								"width": 15,
								"height": 7,
								"orientation": "left"
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"top": 85,
								"left": 10,
								"width": 15,
								"height": 7,
								"orientation": "left"
							}
						]
					},
					{
						"tally": [
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"top": 85,
								"left": 8,
								"width": 17,
								"height": 6,
								"orientation": "left"
							}
						]
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 84,
					"left": 8,
					"width": 15,
					"height": 7,
					"orientation": "left"
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "SteamLinx",
		"partnumber": "SteamLinx",
		"previewname": "SteamLinx",
		"name": "SteamLinx",
		"price": 535,
		"descriptions": {
			"short": "SteamLinx® Wireless Interface",
			"long": "SteamLinx brings the convenience of using your smartphone or mobile device to start your steam shower from anywhere within your home. Get off to a quick start with just a few taps. All the benefits with less effort.",
			"tech": "<li>Use your smartphone or mobile device to control your steam shower</li><li>Whatever your preference, program your temperature and get comfortable</li><li>Use our standard 60-minute timer and take total control of how long you want your steam experience to last</li><li>Bring your steam system into your network</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/0afda6f4-0e68-4d00-826f-640d03f82144.pdf"
		},
		"images": {
			"thumbnail": "steamlinx.jpg",
			"folder": "controls-accessories/",
			"scene": "steamlink_m+l.png"
		},
		"taxonomy": {
			"categories": [
				"controls-accessories"
			],
			"sortOrder": {
				"controls-accessories": 2
			},
			"zIndex": {
				"controls-accessories": 2
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 73,
					"left": 27,
					"width": 4,
					"height": 4,
					"orientation": "left"
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "CHROMASTEAM",
		"partnumber": "MSCHROMA-72",
		"previewname": "ChromaSteam",
		"name": "ChromaSteam",
		"price": 1150,
		"descriptions": {
			"short": "Music Therapy Speakers",
			"long": "Step into your shower. Let the steam envelope you. Now extend a hand and effortlessly dial in just the mood you're seeking. Your elegant, vapor-sealed LED mood lighting responds with a flood of pure energy.",
			"tech": "<li>Suffuses the steam shower with a spectrum of color from airy blue to sensual red</li><li>Vapor-sealed</li><li>Low-voltage LED modules yield long-lasting high performance and cool operation</li><li>The Chroma logic color selection can be set for a single color or to cycle from one to another</li><li>ChromaSteam is UL listed for safety</li>"
		},
		"images": {
			"thumbnail": "ChromaSteam.jpg",
			"folder": "spa-therapies/ChromaSteam/",
			"scene": "ChromaSteam.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/61737f7f-1e0f-4134-bbbb-f37338a4d2d0.pdf"
		},
		"taxonomy": {
			"categories": [
				"spa-therapies"
			],
			"sortOrder": {
				"spa-therapies": 6
			},
			"zIndex": {
				"spa-therapies": 6
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 15,
					"left": 54.7,
					"width": 6,
					"height": 5
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "CHROMASTEAMX",
		"partnumber": "CHROMASTEAMX",
		"previewname": "ChromaX System",
		"name": "ChromaX System",
		"price": 1100,
		"descriptions": {
			"short": "Music Therapy Speakers",
			"long": "ChromaSteam System suffuses the steam shower with a spectrum of color from airy blue to sensual red. Select color and modes directly from the iSteamX Control.Includes a built-in low voltage transformer and color microprocessor.",
			"tech": "<li>Ceiling mounted, vapor-sealed</li><li>Energy efficient LED module</li><li>Color selection microprocessor</li><li>Can be controlled from a dedicated wall switch</li><li>Can be controlled from in-shower control</li><BR><BR>IMPORTANT: ChromaSteam™ System is for mood lighting only and is not a substitute for general illumination."
		},
		"images": {
			"thumbnail": "chroma_blk.jpg",
			"folder": "spa-therapies/ChromaSteam/",
			"scene": "chromasteam_light_bk.png"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/0e8404cb-f535-4476-9a40-b750675dea56.pdf"
		},
		"taxonomy": {
			"categories": [
				"spa-therapies"
			],
			"sortOrder": {
				"spa-therapies": 4
			},
			"zIndex": {
				"spa-therapies": 4
			}
		},
		"options": {
			"enabledListsIds": [
				"color"
			],
			"selected": {
				"color": "BLACK",
				"type": "CHROMAXBK"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "chroma_blk.jpg"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "chroma_wh.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "CHROMAXBK"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "CHROMAXWH"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "chromasteam_light_bk.png"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "chromasteam_light_wh.png"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 15,
					"left": 54.7,
					"width": 6,
					"height": 5
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "AROMASTEAM",
		"partnumber": "MSAROMA",
		"previewname": "AromaSteam System",
		"name": "AromaSteam System",
		"price": 1500,
		"descriptions": {
			"short": "AromaSteam System",
			"long": "Effortlessly infuse your steam shower with the AromaSteam System. This state-of-the-art injector pump electronically atomizes our organic botanical fragrances into your steam at the source, for the most complete and consistent infusion of delightful essences into your steam shower. We’ve raised aroma to an art form.",
			"tech": "<Li>The AromaSteam is easily controlled directly from an iSteam, iTempo Plus and AirTempo in-shower control</Li><Li>Complete with hoses, fittings and oil atomizer</Li><Li>All installation hardware included</Li><li>Install in a dry low humidity location for optimal performance </li>"
		},
		"images": {
			"thumbnail": "MSAROMA.jpg",
			"folder": "spa-therapies/AromaSteam/",
			"scene": "mst2024-02_vspa_aroma-flo-pump_final_01.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/0a8f8aef-9d7b-4865-aa56-24f1c58dee7f.pdf"
		},
		"taxonomy": {
			"categories": [
				"spa-therapies"
			],
			"sortOrder": {
				"spa-therapies": 7
			},
			"zIndex": {
				"spa-therapies": 7
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 77,
					"left": 23.5,
					"width": 7,
					"height": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": false
		}
	},
	{
		"code": "AROMA_STEAM_OIL_1L",
		"partnumber": "MS AROMA",
		"previewname": "AromaSteam Oil",
		"name": "AromaSteam Oil",
		"price": 160,
		"descriptions": {
			"long": "Aromatherapy has been recognized for centuries as having potentially profound healing effects. Aromatherapy was mankind’s first medicine, a holistic practice of caring for the body using botanical oils. Essential oils can help awaken and stimulate, or relax and promote better sleep. The MrSteam Aromas are a unique collection of natural fragrances, available in 1-liter bottles, that enrich the steam experience. Each aromatic oil offers a distinct fragrance with characteristic benefits.",
			"tech": "<li>Infuse your steam with AromaSteam bottles </li><li>Specially formulated & packaged for use with the AromaSteam system</li><li>1 liter bottle </li><li>Approximate 120 20-minute steam sessions </li>"
		},
		"images": {
			"folder": "spa-therapies/AromaSteam-Oils-1l/",
			"thumbnail": "MS-OIL1.jpg",
			"scene": "AromaSteam.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/805b5799-a245-41fb-98e3-44230f966852.pdf"
		},
		"taxonomy": {
			"categories": [
				"spa-therapies"
			],
			"sortOrder": {
				"spa-therapies": 8
			},
			"zIndex": {
				"spa-therapies": 8
			}
		},
		"options": {
			"enabledListsIds": [
				"aroma"
			],
			"selected": {
				"aroma": "EUCALYPTUS"
			},
			"list": {
				"aroma": [
					"EUCALYPTUS",
					"EVERGREEN",
					"BREATHE",
					"LAVENDER",
					"MINT"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"EUCALYPTUS"
							]
						],
						"value": "MS-OIL1.jpg"
					},
					{
						"tally": [
							[
								"EVERGREEN"
							]
						],
						"value": "MS-OIL3.jpg"
					},
					{
						"tally": [
							[
								"BREATHE"
							]
						],
						"value": "MS-OIL5.jpg"
					},
					{
						"tally": [
							[
								"LAVENDER"
							]
						],
						"value": "MS-OIL2.jpg"
					},
					{
						"tally": [
							[
								"MINT"
							]
						],
						"value": "MS-OIL4.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"EUCALYPTUS"
							]
						],
						"value": "MS-OIL1"
					},
					{
						"tally": [
							[
								"EVERGREEN"
							]
						],
						"value": "MS-OIL3"
					},
					{
						"tally": [
							[
								"BREATHE"
							]
						],
						"value": "MS-OIL5"
					},
					{
						"tally": [
							[
								"LAVENDER"
							]
						],
						"value": "MS-OIL2"
					},
					{
						"tally": [
							[
								"MINT"
							]
						],
						"value": "MS-OIL4"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 77,
					"left": 24.5,
					"width": 7,
					"height": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "RECESSED_LIGHT",
		"partnumber": "MSLIGHTRCS",
		"previewname": "Recessed LED Light",
		"name": "Recessed LED Light",
		"price": 950,
		"descriptions": {
			"long": "Built for steam environments, this Recessed Light is designed for ceiling mount and architectural integration. Available in both aluminum polished and aluminum satin finishes, it can fit nearly any steam room design. Complete with 120 VAC LED Driver and rough-in bracket, the impressive 600 lumens light is ready to install in your steam shower.",
			"tech": "<li>Low voltage</li><li>600 lumens</li><li>120 volt</li><li>Includes 120 VAC LED Driver</li><li>Includes rough-in bracket</li><li>3 ½ “ high x 4 ¼” diameter</li><li>UL Listed</li>"
		},
		"images": {
			"thumbnail": "LEDLITE-AP.jpg",
			"folder": "accessories/RecessedLight/",
			"scene": "RecessedLight.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/ea007e32-e745-4a09-8acc-7d0489918ac8.pdf"
		},
		"taxonomy": {
			"categories": [
				"accessories"
			],
			"sortOrder": {
				"accessories": 1
			},
			"zIndex": {
				"accessories": 1
			}
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_ALUMINUM"
			},
			"list": {
				"finish": [
					"POLISHED_ALUMINUM",
					"SATIN_ALUMINUM"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_ALUMINUM"
							]
						],
						"value": "LEDLITE-AP.jpg"
					},
					{
						"tally": [
							[
								"SATIN_ALUMINUM"
							]
						],
						"value": "LEDLITE-AS.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_ALUMINUM"
							]
						],
						"value": "LEDLITE-AP"
					},
					{
						"tally": [
							[
								"SATIN_ALUMINUM"
							]
						],
						"value": "LEDLITE-AS"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_ALUMINUM"
							]
						],
						"value": 950
					},
					{
						"tally": [
							[
								"SATIN_ALUMINUM"
							]
						],
						"value": 950
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 12,
					"left": 49.2,
					"height": 5,
					"width": 5
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "WALL_SEAT",
		"partnumber": "MS WALLSEAT",
		"previewname": "Wall Seat",
		"name": "Wall Seat",
		"price": 675,
		"descriptions": {
			"long": "The Teak in shower wall seat for the home spa offered by Mr. Steam is perfect for sitting and relaxing in steam. The contemporary styled seat easily folds up against the wall for added space when needed in the steam shower. The seat is built to hold up to 250 pounds as well as meeting ADA specifications. ",
			"tech": "<li>Made with beautifully finished and sealed teak wood</li><li>Wall brackets are finished in polished chrome, polished nickel, satin nickel, or brushed nickel</li><li>All nessecary installation hardware is included with seat</li><li>Rated max 250 lbs</li>"
		},
		"images": {
			"thumbnail": "WallSeat.jpg",
			"folder": "accessories/WallSeat/",
			"scene": "Wallseat_PC.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/e39f363d-8e04-4151-ab2e-e3d573d62099.pdf"
		},
		"taxonomy": {
			"categories": [
				"accessories"
			],
			"sortOrder": {
				"accessories": 1
			},
			"zIndex": {
				"accessories": 1
			}
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"finish": [
					"POLISHED_CHROME",
					"POLISHED_NICKEL",
					"BRUSHED_NICKEL",
					"SATIN_BRASS"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "wallseat_pc.png"
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": "wallseat_pn.png"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "wallseat_bn.png"
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": "wallseat_sb.png"
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "MSWSEAT-PC.jpg"
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": "MSWSEAT-PN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSWSEAT-BN.jpg"
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": "MSWSEAT-SB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "MSWSEAT-PC"
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": "MSWSEAT-PN"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSWSEAT-BN"
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": "MSWSEAT-SB"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 735
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							],
							[
								"BRUSHED_NICKEL"
							],
							[
								"SATIN_BRASS"
							]
						],
						"value": 810
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 66,
					"left": 56.5,
					"height": 7,
					"width": 13
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "LINEAR_STEAMHEAD",
		"partnumber": "104216",
		"previewname": "Linear SteamHead",
		"name": "Linear SteamHead",
		"price": 510,
		"descriptions": {
			"long": "Award winning, whisper quite Linear SteamHead matches any design style. Mounts flush to the wall, and creates a wide ribbon of smooth that brings a new level of performance and aesthetic pleasure to your steam shower. Now includes designer finish trim, aroma oil well, and diverter.",
			"tech": "<li>A series of patented interior baffles delivers whisper quiet billowing steam</li><li>Slender, horizontal opening disperses steam evenly and smoothly</li><li>Decorative trim in designer finish pushes in place and is held with silicone/friction</li><li>Aroma oil tray in neutral finish attaches to the steam head with or diverter is included</li><li>Stainless steel diveter can be used to reduce the steam emission if desired is included</li><li>Fits between 16\" on center 2' x 4\" studs</li><li>Anodized hard coat aluminum construction and finish</li><li>Installs flush to the wall and nearly disappears in the grout line</li><li>No assembly of moving parts required</li>"
		},
		"images": {
			"thumbnail": "104480PC.jpg",
			"folder": "accessories/LinearSteamHead/",
			"scene": "LinearSteamHead.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/25133f67-bf80-4b52-a44c-ce57ec32ddbd.pdf"
		},
		"taxonomy": {
			"categories": [
				"controls-accessories"
			],
			"sortOrder": {
				"controls-accessories": 1
			},
			"zIndex": {
				"controls-accessories": 1
			}
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"finish": [
					"POLISHED_CHROME",
					"POLISHED_NICKEL",
					"BRUSHED_NICKEL",
					"BRUSHED_BRONZE",
					"MATTE_BLACK",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"SATIN_BRASS"
				]
			}
		},
		"dynamicProperties": {
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "104480PC"
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": "104480PN"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "104480BN"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "104480BB"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "104480MB"
					},
					{
						"tally": [
							[
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "104480ORB"
					},
					{
						"tally": [
							[
								"POLISHED_BRASS"
							]
						],
						"value": "104480PB"
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": "104480SB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								null,
								"SATIN_BRASS"
							],
							[
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "linear_steamhead_SB.png"
					},
					{
						"tally": [
							[
								null,
								"POLISHED_CHROME"
							],
							[
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "linear_steamhead_PC.png"
					},
					{
						"tally": [
							[
								null,
								"POLISHED_NICKEL"
							],
							[
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "linear_steamhead_PN.png"
					},
					{
						"tally": [
							[
								null,
								"BRUSHED_NICKEL"
							],
							[
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "linear_steamhead_BN.png"
					},
					{
						"tally": [
							[
								null,
								"BRUSHED_BRONZE"
							],
							[
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "linear_steamhead_BB.png"
					},
					{
						"tally": [
							[
								null,
								"MATTE_BLACK"
							],
							[
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "linear_steamhead_MB.png"
					},
					{
						"tally": [
							[
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "linear_steamhead_ORB.png"
					},
					{
						"tally": [
							[
								null,
								"POLISHED_BRASS"
							],
							[
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "linear_steamhead_PB.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "linear_steamhead_double_SB.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "linear_steamhead_double_PC.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "linear_steamhead_double_PN.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "linear_steamhead_double_BN.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "linear_steamhead_double_BB.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "linear_steamhead_double_MB.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "linear_steamhead_double_ORB.png"
					},
					{
						"tally": [
							[
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "linear_steamhead_double_PB.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"POLISHED_BRASS"
							]
						],
						"value": 900
					},
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 750
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "104480PC.jpg"
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": "104480PN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "104480BN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "104480BB.jpg"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "104480MB.jpg"
					},
					{
						"tally": [
							[
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "104480ORB.jpg"
					},
					{
						"tally": [
							[
								"POLISHED_BRASS"
							]
						],
						"value": "104480PB.jpg"
					},
					{
						"tally": [
							[
								"SATIN_BRASS"
							]
						],
						"value": "104480SB.jpg"
					}
				]
			},
			"tooltips.list": {
				"keyTemplate": [
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								null
							],
							[
								"MS90EC1"
							],
							[
								"MS150EC1"
							],
							[
								"MS225EC1"
							],
							[
								"MS400EC1"
							]
						],
						"value": [
							{
								"top": 73.5,
								"left": 38.5,
								"height": 4,
								"width": 6
							}
						]
					},
					{
						"tally": [
							[
								"MSSUPER1EC1"
							],
							[
								"MSSUPER2EC1"
							],
							[
								"MSSUPER3EC1"
							],
							[
								"MX4EC1"
							],
							[
								"MX5EC1"
							],
							[
								"MX6EC1"
							]
						],
						"value": [
							{
								"top": 73,
								"left": 36.5,
								"height": 5,
								"width": 10
							}
						]
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 73.5,
					"left": 38.5,
					"height": 4,
					"width": 6
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": true
		}
	},
	{
		"code": "AROMA_STEAM_OIL",
		"partnumber": "MS AROMA",
		"previewname": "AromaSteam Oil",
		"name": "AromaSteam Oil",
		"price": 450,
		"descriptions": {
			"long": "A deeply refreshing aroma with cleansing effects, eucalyptus may help open air passageways",
			"tech": "10 ml. bottle with integral dropper made from organic plant and flower extracts\\r\\n100% essential oils"
		},
		"images": {
			"folder": "accessories/AromaSteam-Oils/",
			"thumbnail": "AromaSteam-5-pack.jpg",
			"scene": "AromaSteam.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/ca152b1a-3ef0-4dfc-8c79-e4727b24f730.pdf"
		},
		"taxonomy": {
			"categories": [
				"accessories"
			],
			"sortOrder": {
				"accessories": 2
			},
			"zIndex": {
				"accessories": 2
			}
		},
		"options": {
			"enabledListsIds": [
				"aroma"
			],
			"selected": {
				"aroma": "PACK_5"
			},
			"list": {
				"aroma": [
					"PACK_5",
					"EUCALYPTUS",
					"EVERGREEN",
					"BREATHE",
					"LAVENDER",
					"MINT"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"EUCALYPTUS"
							]
						],
						"value": "Eucalyptus.jpg"
					},
					{
						"tally": [
							[
								"EVERGREEN"
							]
						],
						"value": "Evergreen.jpg"
					},
					{
						"tally": [
							[
								"BREATHE"
							]
						],
						"value": "Breathe.jpg"
					},
					{
						"tally": [
							[
								"LAVENDER"
							]
						],
						"value": "Lavender.jpg"
					},
					{
						"tally": [
							[
								"MINT"
							]
						],
						"value": "Mint.jpg"
					},
					{
						"tally": [
							[
								"PACK_5"
							]
						],
						"value": "AromaSteam-5-pack.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"EUCALYPTUS"
							]
						],
						"value": "103810"
					},
					{
						"tally": [
							[
								"EVERGREEN"
							]
						],
						"value": "103812"
					},
					{
						"tally": [
							[
								"BREATHE"
							]
						],
						"value": "103814"
					},
					{
						"tally": [
							[
								"LAVENDER"
							]
						],
						"value": "103811"
					},
					{
						"tally": [
							[
								"MINT"
							]
						],
						"value": "103813"
					},
					{
						"tally": [
							[
								"PACK_5"
							]
						],
						"value": "MS ESSENTIAL 5"
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"EUCALYPTUS"
							]
						],
						"value": "A deeply refreshing aroma with cleansing effects, eucalyptus may help open air passageways"
					},
					{
						"tally": [
							[
								"EVERGREEN"
							]
						],
						"value": "A refreshing blend of spruce, fir and pine reminiscent of a forest on a crisp morning"
					},
					{
						"tally": [
							[
								"BREATHE"
							]
						],
						"value": "A tropical combination that may help clear chest, nose and sinuses"
					},
					{
						"tally": [
							[
								"LAVENDER"
							]
						],
						"value": "A sweet, lightly floral scent, lavender may help soothe anxiety with its calming and restorative properties"
					},
					{
						"tally": [
							[
								"MINT"
							]
						],
						"value": "A blend of mint, citrus and herbs that may stimulate and energize"
					},
					{
						"tally": [
							[
								"PACK_5"
							]
						],
						"value": "5 Pack Essential Oils: Eucalyptus, Evergreen, Breathe, Lavender, Mint"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"EUCALYPTUS"
							],
							[
								"EVERGREEN"
							],
							[
								"BREATHE"
							],
							[
								"LAVENDER"
							],
							[
								"MINT"
							]
						],
						"value": 50
					},
					{
						"tally": [
							[
								"PACK_5"
							]
						],
						"value": 200
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 46.5,
					"left": 45,
					"width": 6,
					"height": 5
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "CHAKRA_OIL",
		"partnumber": "MS CHAKRA7",
		"previewname": "Chakra Oil",
		"name": "Chakra Oil",
		"price": 450,
		"descriptions": {
			"long": "MrSteam® introduces specially formulated essential oils extracted from organic flowers and plant material. The MrSteam Chakra blends may support the body's specific needs. Each MrSteam Chakra oil offers a unique fragrance with characteristic benefits.",
			"tech": "<li>Formulated to work in harmony with the ChromaSteam system's color settings</li><li>Made from organic plant and flower extracts</li><li>10 ml bottles with integral dropper</li><li>For use with towel warmer and steam head wells</li>"
		},
		"images": {
			"folder": "accessories/Chackra-Oils/",
			"thumbnail": "Chackra-Oils-7-pack.jpg",
			"scene": "Chackra-Oils.png"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/2c58532f-9174-4619-b251-eb39942a5c0c.pdf"
		},
		"taxonomy": {
			"categories": [
				"accessories"
			],
			"sortOrder": {
				"accessories": 2
			},
			"zIndex": {
				"accessories": 2
			}
		},
		"options": {
			"enabledListsIds": [
				"aroma"
			],
			"selected": {
				"aroma": "PACK_7"
			},
			"list": {
				"aroma": [
					"PACK_7",
					"VITALITY",
					"INVIGORATE",
					"AWAKENING",
					"HARMONY",
					"CELESTIAL",
					"MYSTIC",
					"NIRVANA"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"VITALITY"
							]
						],
						"value": "Vitality.jpg"
					},
					{
						"tally": [
							[
								"INVIGORATE"
							]
						],
						"value": "Invigorate.jpg"
					},
					{
						"tally": [
							[
								"AWAKENING"
							]
						],
						"value": "Awakening.jpg"
					},
					{
						"tally": [
							[
								"HARMONY"
							]
						],
						"value": "Harmony.jpg"
					},
					{
						"tally": [
							[
								"CELESTIAL"
							]
						],
						"value": "Celestial.jpg"
					},
					{
						"tally": [
							[
								"MYSTIC"
							]
						],
						"value": "Mystic.jpg"
					},
					{
						"tally": [
							[
								"NIRVANA"
							]
						],
						"value": "Nirvana.jpg"
					},
					{
						"tally": [
							[
								"PACK_7"
							]
						],
						"value": "Chackra-Oils-7-pack.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"VITALITY"
							]
						],
						"value": "104006"
					},
					{
						"tally": [
							[
								"INVIGORATE"
							]
						],
						"value": "104007"
					},
					{
						"tally": [
							[
								"AWAKENING"
							]
						],
						"value": "104008"
					},
					{
						"tally": [
							[
								"HARMONY"
							]
						],
						"value": "104009"
					},
					{
						"tally": [
							[
								"CELESTIAL"
							]
						],
						"value": "104010"
					},
					{
						"tally": [
							[
								"MYSTIC"
							]
						],
						"value": "104011"
					},
					{
						"tally": [
							[
								"NIRVANA"
							]
						],
						"value": "104012"
					},
					{
						"tally": [
							[
								"PACK_7"
							]
						],
						"value": "MS CHAKRA7"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.aroma"
				],
				"tallies": [
					{
						"tally": [
							[
								"CELESTIAL"
							],
							[
								"VITALITY"
							],
							[
								"INVIGORATE"
							],
							[
								"AWAKENING"
							],
							[
								"HARMONY"
							],
							[
								"MYSTIC"
							],
							[
								"NIRVANA"
							]
						],
						"value": 55
					},
					{
						"tally": [
							[
								"PACK_7"
							]
						],
						"value": 260
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 46.5,
					"left": 45,
					"width": 6,
					"height": 5
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "AIRBUTLER_PACKAGE",
		"partnumber": "ABUTLER",
		"previewname": "AirButler Package",
		"name": "AirButler Package",
		"price": 1950,
		"descriptions": {
			"short": "AirButlerWhite",
			"long": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat.",
			"tech": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>",
			"parts": "test"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/87dca122-a38e-4002-9255-81ceb75eb37b.pdf"
		},
		"taxonomy": {
			"categories": [
				"airtempo-wireless-controls"
			]
		},
		"images": {
			"folder": "control-packages/AirButler/",
			"thumbnail": "ABUTLER1B-PC.jpg"
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish",
				"steamHead"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME",
				"steamHead": "AIRTEMPO_STEAMHEAD"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				],
				"steamHead": [
					"AIRTEMPO_STEAMHEAD",
					"LINEAR_STEAMHEAD"
				]
			}
		},
		"dynamicProperties": {
			"price": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 3255
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 2755
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 3255
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 4030
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 2755
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 3180
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3380
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3505
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 4430
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3005
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3380
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "We're here to help you build a personal oasis. But you wanted that oasis to be wireless. So we engineered a steam shower control that gives you an unmatched experience along with the convenience of a remote control. With no wires and no hassle, you're free to get lost in your steam shower retreat."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The completely wireless, 100% water proof AirTempo Control is the centerpiece of this package. This sleek and elegant control mounts effortlessly just about anywhere you want it and is ideal for retrofits. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at a substantial discount."
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Not tethered by cables. You can use the control up to 60 feet away from the generator</li><li>Transform your senses with optional Chromatic Lighting & Aromatic Infusers</li><li>Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature</li><li>Create profiles for custom settings for temperature, time and more</li><li>Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit</li><li>No need to run wires, great solution for covering a hole left by an old steam shower control</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> Not tethered by cables. You can use the control up to 60 feet away from the generator </li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers </li><li> Quickly responds to user's touch inputs and reverts to sleep mode automatically when left idle while maintaining the set temperature </li><li> Create profiles for custom settings for temperature, time and more</li><li> Mount to nearly any hard surface or flush to the wall using a Flush Mount Kit </li><li> No need to run wires, great solution for covering a hole left by an old steam shower control </li>"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li> AirTempo SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo Wireless Steam Shower Control</li><li>SteamLinx</li><li>Linear SteamHead</li><li> AutoFlush®</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> AirTempo™ Surface mount Control</li><li>Linear SteamHead (2)</li><li> SteamLinx</li><li> Max AutoFlush®</li><li>Max Condensation Pan</li>"
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLER1B-PC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLER1B-BB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLER1B-BN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLER1B-ORB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLER1B-PB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLER1B-PN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLER1B-SB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABUTLER1B-MB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLER1W-PC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLER1W-BB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLER1W-BN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLER1W-ORB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLER1W-PB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLER1W-PN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLER1W-SB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABUTLER1W-MB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERLBKPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERLBKBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERLBKBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERLBKORB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERLBKPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERLBKPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERLBKSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABTLRLBKMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERLWHPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERLWHBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERLWHBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERLWHORB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERLWHPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERLWHPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERLWHSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABTLRLWHMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERXB-PC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERXB-BB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERXB-BN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERXB-ORB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERXB-PB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERXB-PN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERXB-SB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABUTLERXB-MB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERXW-PC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERXW-BB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERXW-BN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERXW-ORB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERXW-PB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERXW-PN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERXW-SB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABUTLERXW-MB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERLXBPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERLXBBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERLXBBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERLXBORB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERLXBPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERLXBPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERLXBSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABTLRLXBKMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERLXWPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERLXWBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERLXWBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERLXWORB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERLXWPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERLXWPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERLXWSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABTLRLXWHMB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLER1B-PC"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLER1B-BB"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLER1B-BN"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLER1B-OR"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLER1B-PB"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLER1B-PN"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLER1B-SB"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "ABUTLER1B-MB"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLER1W-PC"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLER1W-BB"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLER1W-BN"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLER1W-OR"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLER1W-PB"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLER1W-PN"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLER1W-SB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABTLRLBKPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABTLRLBKBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABTLRLBKBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABTLRLBKORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABTLRLBKPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABTLRLBKPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABTLRLBKSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABTLRLWHPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABTLRLWHBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABTLRLWHBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABTLRLWHORB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABTLRLWHPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABTLRLWHPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABTLRLWHSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERXB-PC"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERXB-BB"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERXB-BN"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERXB-OR"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERXB-PB"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERXB-PN"
					},
					{
						"tally": [
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERXB-SB"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABUTLERXW-PC"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABUTLERXW-BB"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABUTLERXW-BN"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABUTLERXW-OR"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABUTLERXW-PB"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABUTLERXW-PN"
					},
					{
						"tally": [
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABUTLERXW-SB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABTLRLXBKPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABTLRLXBKBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABTLRLXBKBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABTLRLXBKORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABTLRLXBKPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABTLRLXBKPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABTLRLXBKSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "ABTLRLXWHPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "ABTLRLXWHBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "ABTLRLXWHBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "ABTLRLXWHORB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "ABTLRLXWHPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "ABTLRLXWHPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "ABTLRLXWHSB"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								null
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS90EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS150EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS225EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MS400EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"productId": "AIRTEMPO_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"AIRTEMPO_STEAMHEAD",
								"MX4EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX5EC1"
							],
							[
								"AIRTEMPO_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "AIRTEMPO_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "AIRTEMPO_CONTROL",
						"quantity": 1
					},
					{
						"productId": "SteamLinx",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "BUTLER_PACKAGE",
		"partnumber": "MSBUTLER",
		"previewname": "Butler Package",
		"name": "Butler Package",
		"price": 2580,
		"descriptions": {
			"short": "Take the stress out of stress relief. Everything you need to get started is in one convenient -- and discounted -- package.",
			"long": "Its never been easier to optimize your steam shower experience. With an elegant design and easy to use interface, you can control more than steam. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center.",
			"tech": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/dcf45949-fdc5-42ac-b825-59f139ef9bff.pdf"
		},
		"taxonomy": {
			"categories": [
				"itempo-plus-controls"
			],
			"sortOrder": {
				"itempo-plus-controls": 1
			},
			"zIndex": {
				"itempo-plus-controls": 1
			}
		},
		"images": {
			"folder": "control-packages/Butler/",
			"thumbnail": "MSBUTLER1SQ-PC.jpg"
		},
		"options": {
			"enabledListsIds": [
				"shape",
				"finish",
				"steamHead"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME",
				"steamHead": "ITEMPO_STEAMHEAD"
			},
			"list": {
				"shape": [
					"SQUARE",
					"ROUND"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"WHITE",
					"BLACK",
					"MATTE_BLACK"
				],
				"steamHead": [
					"ITEMPO_STEAMHEAD",
					"LINEAR_STEAMHEAD"
				]
			}
		},
		"dynamicProperties": {
			"price": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							]
						],
						"value": 2905
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							]
						],
						"value": 2580
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							]
						],
						"value": 2905
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							]
						],
						"value": 2580
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 2905
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"RAW"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 2580
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"RAW"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 2905
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 3680
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 2580
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 2930
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC2",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": 3230
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3030
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 4080
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 2730
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 3230
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLER1SQ-PC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLER1SQ-BB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLER1SQ-BN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLER1SQ-ORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLER1SQ-PB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLER1SQ-PN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLER1SQ-SB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLER1SQ-WH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLER1SQ-BK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLER1SQ-MB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLER1RD-PC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLER1RD-BB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLER1RD-BN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLER1RD-ORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLER1RD-PB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLER1RD-PN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLER1RD-SB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLER1RD-WH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLER1SQ-BK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLER1RD-MB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERL1SQPC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERL1SQBB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERL1SQBN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERL1SQORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERL1SQPB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERL1SQPN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERL1SQSB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BUTLERL1SQWH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BUTLERL1SQBK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERL1SQMB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERL1RDPC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERL1RDBB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERL1RDPN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERL1RDORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERL1RDPB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERL1RDPN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERL1RDSB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BUTLERL1RDWH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BUTLERL1RDBK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERL1RDMB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXSQ-PC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-BB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-BN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-ORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-PB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-PN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-SB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLERXSQ-BK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXSQ-BK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXSQ-WH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXRD-PC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-BB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-BN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-ORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXRD-PB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-PN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXRD-SB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLERXRD-BK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXRD-BK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXRD-WH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERLXSPC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERLXSBB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERLXSBN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERLXSORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERLXSPB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERLXSPN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERLXSSB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "BUTLERLXSWH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BUTLERLXSBK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERLXSBK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERLXRPC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERLXRBB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERLXRBN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERLXRORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERLXRPB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERLXRPN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERLXRSB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "BUTLERLXRWH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BUTLERLXRBK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERLXRBK.jpg"
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, an Aroma Designer SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The Butler Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. A matching Linear SteamHead, an AutoFlush, and a Condensation Pan. Connect AromaSteam and ChromaSteam systems to create a personalized wellness center."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "It has never been easier to optimize your steam shower experience with the Butler MAX Package. With an elegant design and easy to use interface, you can control more than steam. Featuring the iTempoPlus Control, it includes the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill, two Aroma Glass SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "The Butler MAX Linear Package features the iTempoPlus Control and the award-winning Linear SteamHead. With an elegant design and easy to use interface, you can control more than steam, It has never been easier to optimize your steam shower experience. Including the SteamLinx Module and Mobile App that enables the Amazon Alexa Skill. Two matching Linear SteamHeads, a MAX AutoFlush, and a MAX Condensation Pan. Our MAX Packages make designing your large residential steam shower easy by providing everything you need, at package savings discounts."
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>Set the perfect steam temperature for multiple users</li><li>ChromaX lighting & AromaSteam infusion</li><li>Never wonder what time, day or date it is in your SteamShower or bathroom</li><li>Manufactured in strong, durable and long lasting solid brass</li><li>Compliment any bathroom design with one of 11 designer or glass finishes</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Aroma Designer SteamHeads that match the iTempoPlus Control and feature an oil reservoir discretely hidden at the top of the steam head</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li> For MX4E - MX6E Generators </li><li>2 Award-Winning Linear SteamHeads, that are whisper quiet, install flush with the wall and can be tiled so only a slim opening remains visible.</li><li> SteamLinx Module, Mobile App allows for seamless control of all your steam room functionality using your smart phone or mobile device</li><li> Transform your senses with optional Chromatic Lighting & Aromatic Infusers through the SteamShower Control </li><li> Max Auto Flush and Max Condensation Pan Suitable for all MAX Residential Generators, model numbers MX4E - MX6E </li>"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>iTempo Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Plus Control</li><li>SteamLinx</li><li>Linear Steamhead</li><li>AutoFlush</li><li>Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLER1SQ-PC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLER1SQ-BB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLER1SQ-BN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLER1SQ-ORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLER1SQ-PB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLER1SQ-PN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLER1SQ-SB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLER1SQ-WH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLER1SQ-BK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLER1SQ-MB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLER1RD-PC"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLER1RD-BB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLER1RD-BN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLER1RD-ORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLER1RD-PB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLER1RD-PN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLER1RD-SB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLER1RD-WH"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLER1RD-BK"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLER1RD-MB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BTLRL1SPC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BTLRL1SBB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BTLRL1SBN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BTLRL1SORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BTLRL1SPB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BTLRL1SPN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BTLRL1SSB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BTLRL1SWH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BTLRL1SBK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BTLRL1SMB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BTLRL1RPC"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BTLRL1RBB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BTLRL1RBN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BTLRL1RORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BTLRL1RPB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BTLRL1RPN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BTLRL1RSB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BTLRL1RWH"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BTLRL1RBK"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BTLRL1RMB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXSQ-PC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-BB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-BN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-ORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-PB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-PN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-SB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLERXSQ-BK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXSQ-MB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXSQ-WH"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXRD-PC"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-BB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-BN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-ORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXRD-PB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-PN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXRD-SB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLERXRD-BK"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXRD-MB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXRD-WH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BTLRLXSPC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BTLRLXSBB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BTLRLXSBN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BTLRLXSORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BTLRLXSPB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BTLRLXSPN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BTLRLXSSB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							]
						],
						"value": "BTLRLXSWH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BTLRLXSBK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BTLRLXSMB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BTLRLXRPC"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BTLRLXRBB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BTLRLXRBN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BTLRLXRORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BTLRLXRPB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BTLRLXRPN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BTLRLXRSB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "BTLRLXRWH"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BTLRLXRBK"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BTLRLXRMB"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "ITEMPO_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ITEMPO_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ITEMPO_CONTROL",
						"quantity": 1
					},
					{
						"productId": "SteamLinx",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "BASIC_BUTLER_PACKAGE",
		"partnumber": "MSBUTLER",
		"previewname": " Basic Butler Package",
		"name": "Basic Butler Package",
		"price": 1695,
		"descriptions": {
			"short": "Take the stress out of stress relief. Everything you need to get started is in one convenient -- and discounted -- package.",
			"long": "All the elements you need to add steam to your home.  This package featuring the classic iTempo Control. Forged from solid brass and available in your choice of 10 designer finishes, iTempo and the matching Linear steam head meshes seamlessly with any bathroom décor.",
			"tech": "<li>Compliment any bathroom design with one of 11 designer or glass finishes</li><li>Includes matching Aroma SteamHead</li><li>iTempo Control Mounts flush to the wall</li><li>Digital display lets you program temperature</li><li>Set the duration of your steam sessions</li><li>Compatible with SteamLinx Module</li><li>iTempo is manufactured in strong, durable and long-lasting solid brass</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/df2b1337-01b2-4585-9212-3d9211ff9697.pdf"
		},
		"taxonomy": {
			"categories": [
				"itempo-controls"
			],
			"sortOrder": {
				"itempo-controls": 1
			},
			"zIndex": {
				"itempo-controls": 1
			}
		},
		"images": {
			"folder": "control-packages/BasicButler/",
			"thumbnail": "BBUTLERSPC.jpg"
		},
		"options": {
			"enabledListsIds": [
				"shape",
				"finish",
				"steamHead"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME",
				"steamHead": "ITEMPO_STEAMHEAD"
			},
			"list": {
				"shape": [
					"SQUARE",
					"ROUND"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"WHITE",
					"BLACK",
					"MATTE_BLACK",
					"RAW"
				],
				"steamHead": [
					"ITEMPO_STEAMHEAD",
					"LINEAR_STEAMHEAD"
				]
			}
		},
		"dynamicProperties": {
			"price": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							]
						],
						"value": 1850
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							]
						],
						"value": 1550
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							]
						],
						"value": 1850
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							]
						],
						"value": 1550
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 1850
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 1550
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 2195
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 1695
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 2195
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 2195
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 1695
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 1695
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC2",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 2545
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 1895
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 1895
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERSPC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERSBB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERSBN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERSORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERSPB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERSPN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERSSB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERSWH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERSBK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERSMB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"RAW"
							]
						],
						"value": "BBUTLERSRAW.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERRPC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERRBB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERRBN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERRORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERRPB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERRPN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERRSB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERRWH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERRBK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERRMB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"RAW"
							]
						],
						"value": "BBUTLERRRAW.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERLSPC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERLSBB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERLSBN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERLSORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERLSPB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERLSPN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERLSSB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERLSWH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERLSBK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERLSMB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"RAW"
							]
						],
						"value": "BBUTLERLSRAW.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERLRPC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERLRBB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERLRBN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERLRORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERLRPB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERLRPN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERLRSB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERLRWH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERLRBK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERLRMB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"RAW"
							]
						],
						"value": "BBUTLERLRRAW.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXSQ-PC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-BB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-BN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-ORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-PB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-PN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-SB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXSQ-BK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXSQ-WH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXSQ-MB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"RAW"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"RAW"
							]
						],
						"value": "MSBUTLERXSQ-RAW.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXRD-PC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-BB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-BN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-ORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXRD-PB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-PN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXRD-SB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXRD-MB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXRD-WH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"RAW"
							]
						],
						"value": "MSBUTLERXRD-RAW.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"RAW"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"RAW"
							]
						],
						"value": "MSBUTLERXRD-RAW.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERLXSPC.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERLXSBB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERLXSBN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERLXSORB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERLXSPB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERLXSPN.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERLXSSB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							]
						],
						"value": "BUTLERLXSWH.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BUTLERLXSBK.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERLXSMB.jpg"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"RAW"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"RAW"
							]
						],
						"value": "BUTLERLXSRAW.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERLXRPC.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERLXRBB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERLXRBN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERLXRORB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERLXRPB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERLXRPN.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERLXRSB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "BUTLERLXRWH.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BUTLERLXRBK.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERLXRMB.jpg"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"RAW"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"RAW"
							]
						],
						"value": "BUTLERLXRRAW.jpg"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>iTempo Control</li><li>Aroma Glass SteamHead</li><li>AutoFlush</li><li> Condensation Pan</li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> AromaSteam Glass SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "<li>AirTempo™ Surface mount Control</li><li> Linear SteamHead (2) </li><li> SteamLinx</li><li> Max AutoFlush®</li><li> Max Condensation Pan </li>"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.shape",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERSPC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERSBB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERSBN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERSORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERSPB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERSPN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERSSB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERSWH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERSBK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERSMB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERRPC"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERRBB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERRBN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERRORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERRPB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERRPN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERRSB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERRWH"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERRBK"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERRMB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERLSPC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERLSBB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERLSBN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERLSORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERLSPB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERLSPN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERLSSB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERLSWH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERLSBK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERLSMB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BBUTLERLRPC"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BBUTLERLRBB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BBUTLERLRBN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BBUTLERLRORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BBUTLERLRPB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BBUTLERLRPN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BBUTLERLRSB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"WHITE"
							]
						],
						"value": "BBUTLERLRWH"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BLACK"
							]
						],
						"value": "BBUTLERLRBK"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BBUTLERLRMB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXSQ-PC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-BB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-BN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXSQ-ORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-PB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXSQ-PN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXSQ-SB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLERXSQ-BK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXSQ-MB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXSQ-WH"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								null,
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "MSBUTLERXRD-PC"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-BB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-BN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "MSBUTLERXRD-ORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "MSBUTLERXRD-PB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "MSBUTLERXRD-PN"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "MSBUTLERXRD-SB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "MSBUTLERXRD-BK"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "MSBUTLERXRD-MB"
					},
					{
						"tally": [
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"ITEMPO_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "MSBUTLERXRD-WH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERLXSPC"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERLXSBB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERLXSBN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERLXSORB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERLXSPB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERLXSPN"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERLXSSB"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							]
						],
						"value": "BUTLERLXSWH"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BUTLERLXSBK"
					},
					{
						"tally": [
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"SQUARE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERLXSMB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BUTLERLXRPC"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BUTLERLXRBB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BUTLERLXRBN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BUTLERLXRORB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BUTLERLXRPB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BUTLERLXRPN"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BUTLERLXRSB"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"WHITE"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"WHITE"
							]
						],
						"value": "BUTLERLXRWH"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BLACK"
							]
						],
						"value": "BUTLERLXRBK"
					},
					{
						"tally": [
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ROUND",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BUTLERLXRMB"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								null
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS90EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS150EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS225EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "ITEMPO_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MSSUPER3EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX4EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX5EC1"
							],
							[
								"ITEMPO_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ITEMPO_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ITEMPO_CONTROL",
						"quantity": 1
					},
					{
						"productId": "SteamLinx",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "DIGITAL_TIMER",
		"partnumber": "103588DIG",
		"previewname": "Digital Timer",
		"name": "Digital Timer",
		"price": 120,
		"descriptions": {
			"short": "Digital Timer",
			"long": "Ready When You Are In-wall, 24-hour electronic timer for pre-start and automatic shut-off of the towel warmer at programmed times. White plate standard. Designer finishes plates available."
		},
		"links": {
			"tech": "http://www.mrsteam.com/Media/Default/Products/DigitalTimer/Digital%20Timer%20Technical%20Sheet.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-accessories"
			]
		},
		"images": {
			"folder": "towel-warmers-accessories/Digital-Timer/",
			"thumbnail": "DigitalTimer.jpg",
			"scene": "DigitalTimer.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_NICKEL",
					"STAINLESS_STEEL_BRUSHED",
					"STAINLESS_STEEL_POLISHED",
					"WHITE"
				]
			}
		},
		"dynamicProperties": {
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "DigitalTimer-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "DigitalTimer-BrushedNickel.png"
					},
					{
						"tally": [
							[
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "DigitalTimer-OilRubbedBronze.png"
					},
					{
						"tally": [
							[
								"POLISHED_NICKEL"
							]
						],
						"value": "DigitalTimer-PolishedNickel.png"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "DigitalTimer-StainlessSteelBrushed.png"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "DigitalTimer-StainlessSteelPolished.png"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "DigitalTimer-White.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 120
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							],
							[
								"OIL_RUBBED_BRONZE"
							],
							[
								"POLISHED_NICKEL"
							],
							[
								"STAINLESS_STEEL_BRUSHED"
							],
							[
								"STAINLESS_STEEL_POLISHED"
							],
							[
								"WHITE"
							]
						],
						"value": 130
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 50,
					"left": 88.8,
					"height": 6,
					"width": 3
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "xDream_PACKAGE",
		"partnumber": "xDream",
		"previewname": "xDream Package",
		"name": "xDream Package",
		"price": 6900,
		"descriptions": {
			"short": "Innovation, luxury, and ease are at the core of the flagship xDream spa package.",
			"long": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>",
			"tech": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>",
			"parts": "test"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/64fcb529-4d88-43ae-9c27-a25d27512a34.pdf"
		},
		"taxonomy": {
			"categories": [
				"isteamx-touch-screen-controls"
			]
		},
		"images": {
			"folder": "control-packages/xDream/",
			"thumbnail": "XDRM1BKPC.jpg",
			"scene": "idream_package_black.png"
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish",
				"steamHead"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME",
				"steamHead": "ISTEAM_STEAMHEAD"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"steamHead": [
					"ISTEAM_STEAMHEAD",
					"LINEAR_STEAMHEAD"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"price": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 7200
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 6900
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 7200
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 7200
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 8000
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 6900
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 7200
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 7400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 7400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 7400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 7400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 7400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 7400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 7500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 8300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 7100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 7400
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Your dream steam shower has arrived. The xDream Package allows you to take total control over every detail of your steam shower experience. With the sophisticated and intuitive iSteamX, Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, and more.</p>"
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The xDream Package includes the iSteamX control, intuitively designed for a tailored user experience</li><li>The xDream Package includes the Aroma Glass SteamHead, available in many designer finishes to match any décor</li><li>Package includes the Bluetooth audio sound AudioX System designed for wet, high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses aroma fragrance into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan</li></p>"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li>(1) Aroma Glass SteamHead </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li>(1) Aroma Glass SteamHead </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li>(1) 16 inch Linear SteamHead  </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li>(1) 16 inch Linear SteamHead  </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li> (2) AromaSteam Glass SteamHeads in black   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li> (2) AromaSteam Glass SteamHeads in white   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li> (2)  Linear SteamHeads in black   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li> (2)  Linear SteamHeads in white   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_package_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_package_2_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_package_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_package_2_white.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_linear_package_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_2_linear_package_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_linear_package_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_2_linear_package_white.png"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKOR"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKLPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKLBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKLBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKLORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKLPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKLPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKLSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKLMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHLPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHLBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHLBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHLOR"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHLPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHLPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHLSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHLMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKXPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKXBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKXBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKXOR"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKXPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKXPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKXSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKXMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHXPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHXBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHXBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHXOR"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHXPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHXPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHXSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHXMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKXLPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKXLBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKXLBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKXLORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKXLPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKXLPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKXLSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKXLMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHXLPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHXLBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHXLBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHXLORB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHXLPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHXLPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHXLSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHXLMB"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAM_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAM_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKOR.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKLPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKLBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKLBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKLOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKLPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKLPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKLSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKLMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHLPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHLBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHLBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHLOR.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHLPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHLPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHLSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHLMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKXPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKXBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKXBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKXOR.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKXPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKXPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKXSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKXMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHXPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHXBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHXBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHXOR.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHXPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHXPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHXSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHXMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1BKXLPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1BKXLBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1BKXLBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1BKXLOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1BKXLPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1BKXLPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1BKXLSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1BKXLMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "XDRM1WHXLPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "XDRM1WHXLBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "XDRM1WHXLBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "XDRM1WHXLOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "XDRM1WHXLPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "XDRM1WHXLPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "XDRM1WHXLSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "XDRM1WHXLMB.jpg"
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ISTEAMX_CONTROL",
						"quantity": 1
					},
					{
						"productId": "AROMASTEAM",
						"quantity": 1
					},
					{
						"productId": "CHROMASTEAMX",
						"quantity": 1
					},
					{
						"productId": "SteamLinx",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "Bliss_PACKAGE",
		"partnumber": "Bliss",
		"previewname": "Bliss Package",
		"name": "Bliss Package",
		"price": 6900,
		"descriptions": {
			"short": "Innovation, luxury, and ease are at the core of the flagship Bliss spa package.",
			"long": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>",
			"tech": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>",
			"parts": "test"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/cc301597-83e9-453c-ae5f-5f39542829b6.pdf"
		},
		"taxonomy": {
			"categories": [
				"isteamx-touch-screen-controls"
			]
		},
		"images": {
			"folder": "control-packages/Bliss/",
			"thumbnail": "BLS-BKPC.jpg",
			"scene": "idream_package_black.png"
		},
		"options": {
			"enabledListsIds": [
				"color",
				"finish",
				"steamHead"
			],
			"selected": {
				"shape": "SQUARE",
				"color": "BLACK",
				"finish": "POLISHED_CHROME",
				"steamHead": "ISTEAM_STEAMHEAD"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				],
				"steamHead": [
					"ISTEAM_STEAMHEAD",
					"LINEAR_STEAMHEAD"
				],
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_BRONZE",
					"BRUSHED_NICKEL",
					"OIL_RUBBED_BRONZE",
					"POLISHED_BRASS",
					"POLISHED_NICKEL",
					"SATIN_BRASS",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"price": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 9200
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							]
						],
						"value": 8900
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 9200
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 9200
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 10000
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 8900
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": 9200
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": 9400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": 9400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": 9400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": 9400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": 9400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": 9400
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 9500
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 10300
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": 9100
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": 9400
					}
				]
			},
			"descriptions.long": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”>Welcome the ultimate shower experience, the Bliss Package. The bliss package is a curated collection of the finest steam systems and shower experiences available. Anchored by the sophisticated and intuitive iSteamX, along with Chroma, Aroma, and Music Therapy systems, AromaGlass Steam Head, AutoFlush system, Condensation Pan, and now completely blissful with the addition of the innovative SpaH2O electronic shower valve.</p>"
					}
				]
			},
			"descriptions.tech": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<p align=”justify”><li>The new MrSteam Bliss Package introduces the SpaH2O digital shower valve system</li><li> This electronic valve syncs with the iSteamX control for seamless control of your shower and steam systems</li><li>Bliss Package includes the AudioX System, the best in Bluetooth audio sound designed for wet high-heat environments</li><li>Package includes the ChromaX System offering 78,N/AN/AN/A color selection possibilities</li><li>Package includes the AromaSteam System which directly infuses specially formulated aroma fragrances into the steam line</li><li>Package includes a 1-liter bottle of Eucalyptus Fragrance for use with the Aroma Steam System</li><li>Package includes the AutoFlush System, offering clean steam every time</li><li>Package includes a Condensation Pan that helps insure a dry and clean environment for you steam generator</li></p>"
					}
				]
			},
			"descriptions.parts": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li>(1) Aroma Glass SteamHead </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li>(1) Aroma Glass SteamHead </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li>(1) 16 inch Linear SteamHead  </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li>(1) 16 inch Linear SteamHead  </li><li>(1) SteamLinx</li><li>(1) AutoFlush </li><li>(1) Condensation Pan</li><li> (1) AromaSteam Oil Delivery System </li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li> (2) AromaSteam Glass SteamHeads in black   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li> (2) AromaSteam Glass SteamHeads in white   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in black  </li><li> (2)  Linear SteamHeads in black   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in black</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "<li>  (1) iSteamX Touch Screen Control in white  </li><li> (2)  Linear SteamHeads in white   </li><li>(1) SteamLinx</li><li>(1) Max AutoFlush </li><li>(1) Max Condensation Pan</li><li> (1) AromaSteam Oil Delivery System with Caddy</li><li>(1) ChromaX Mood Lighting System</li><li>(1) Pair of Square In-shower Music Therapy Speakers in white</li><li>(1) Liter Eucalyptus Oil with Caddy</li>"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_package_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_package_2_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_package_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_package_2_white.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_linear_package_black.png"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_2_linear_package_black.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": "idream_linear_package_white.png"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": "idream_2_linear_package_white.png"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKLPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKLBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKLBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKLORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKLPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKLPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKLSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKLMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHLPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHLBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHLBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHLORB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHLPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHLPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHLSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHLMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKXPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKXBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKXBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKXOB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKXPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKXPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKXSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKXMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHXPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHXBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHXBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHXOB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHXPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHXPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHXSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHXMB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKXLPC"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKXLBB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKXLBN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKXLORB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKXLPB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKXLPN"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKXLSB"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKXLMB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHXLPC"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHXLBB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHXLBN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHXLORB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHXLPB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHXLPN"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHXLSB"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHXLMB"
					}
				]
			},
			"package.config.dynamicProducts.selectedGenerator": {
				"keyTemplate": [
					"options.selected.steamHead",
					"_globals.selectedGenerator"
				],
				"tallies": [
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								null
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS90EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS150EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS225EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MS400EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAM_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"ISTEAM_STEAMHEAD",
								"MX4EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX5EC1"
							],
							[
								"ISTEAM_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "ISTEAM_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								null
							],
							[
								"LINEAR_STEAMHEAD",
								"MS90EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS150EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS225EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MS400EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 1
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 1
							},
							{
								"productId": "Condensation Pan",
								"quantity": 1
							}
						]
					},
					{
						"tally": [
							[
								"LINEAR_STEAMHEAD",
								"MX4EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX5EC1"
							],
							[
								"LINEAR_STEAMHEAD",
								"MX6EC1"
							]
						],
						"value": [
							{
								"productId": "LINEAR_STEAMHEAD",
								"quantity": 2
							},
							{
								"productId": "AUTOFLUSH",
								"quantity": 2
							},
							{
								"productId": "Condensation Pan",
								"quantity": 2
							}
						]
					}
				]
			},
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color",
					"options.selected.steamHead",
					"_globals.selectedGenerator",
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKLPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKLBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKLBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKLOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKLPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKLPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKLSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKLMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHLPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHLBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHLBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHLOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHLPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHLPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHLSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								null,
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS90EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS150EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS225EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MS400EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER1EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER2EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MSSUPER3EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHLMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKXPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKXBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKXBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKXOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKXPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKXPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKXSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKXMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHXPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHXBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHXBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHXOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHXPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHXPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHXSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"ISTEAM_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHXMB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-BKXLPC.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-BKXLBB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-BKXLBN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-BKXLOB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-BKXLPB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-BKXLPN.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-BKXLSB.jpg"
					},
					{
						"tally": [
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"BLACK",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-BKXLMB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_CHROME"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_CHROME"
							]
						],
						"value": "BLS-WHXLPC.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_BRONZE"
							]
						],
						"value": "BLS-WHXLBB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"BRUSHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"BRUSHED_NICKEL"
							]
						],
						"value": "BLS-WHXLBN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"OIL_RUBBED_BRONZE"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"OIL_RUBBED_BRONZE"
							]
						],
						"value": "BLS-WHXLOB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_BRASS"
							]
						],
						"value": "BLS-WHXLPB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"POLISHED_NICKEL"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"POLISHED_NICKEL"
							]
						],
						"value": "BLS-WHXLPN.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"SATIN_BRASS"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"SATIN_BRASS"
							]
						],
						"value": "BLS-WHXLSB.jpg"
					},
					{
						"tally": [
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX4EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX5EC1",
								"MATTE_BLACK"
							],
							[
								"WHITE",
								"LINEAR_STEAMHEAD",
								"MX6EC1",
								"MATTE_BLACK"
							]
						],
						"value": "BLS-WHXLMB.jpg"
					}
				]
			}
		},
		"package": {
			"config": {
				"staticProducts": [
					{
						"productId": "ISTEAMX_CONTROL",
						"quantity": 1
					},
					{
						"productId": "AROMASTEAM",
						"quantity": 1
					},
					{
						"productId": "CHROMASTEAMX",
						"quantity": 1
					},
					{
						"productId": "SteamLinx",
						"quantity": 1
					}
				]
			}
		},
		"vSpa": {
			"spaFrameSourceOption": "finish",
			"spaFrameIsVisible": true,
			"standardGeneratorIsVisible": true,
			"isSuperCompatible": true
		}
	},
	{
		"code": "CHROMASTEAMDUOX",
		"partnumber": "CHROMASTEAMDUOX",
		"previewname": "ChromaX Duo System",
		"name": "ChromaX Duo System",
		"price": 1950,
		"descriptions": {
			"short": "Music Therapy Speakers",
			"long": "Step into your shower. Let the steam envelope you. Now extend a hand and effortlessly dial in just the mood you're seeking. Your elegant, vapor-sealed LED mood lighting will respond with a flood of pure energy.\\r\\n\\r\\n",
			"tech": "<li>Select color and modes directly from the iSteamX control</li><li>Can also be controlled from a dedicated wall switch</li><li>Included low voltage power supply</li><li>Works with all Mr.Steam eSeries Generators</li><li>Includes two Chroma light and control module</li>"
		},
		"images": {
			"thumbnail": "ChromaXDUOBK.jpg",
			"folder": "spa-therapies/ChromaSteamX/",
			"scene": "chromasteam_light_bk.png"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/0e8404cb-f535-4476-9a40-b750675dea56.pdf"
		},
		"taxonomy": {
			"categories": [
				"spa-therapies"
			],
			"sortOrder": {
				"spa-therapies": 4
			},
			"zIndex": {
				"spa-therapies": 4
			}
		},
		"options": {
			"enabledListsIds": [
				"color"
			],
			"selected": {
				"color": "BLACK",
				"type": "CHROMAXBK"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "ChromaXDUOBK.jpg"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "ChromaXDUOWH.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "CHROMAXDUOBK"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "CHROMAXDUOWH"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "chromasteam_light_bk.png"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "chromasteam_light_wh.png"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 15,
					"left": 54.7,
					"width": 6,
					"height": 5
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "AUDIOX",
		"partnumber": "AUDIOX",
		"previewname": "AudioX",
		"name": "AudioX",
		"price": 895,
		"descriptions": {
			"short": "Music Therapy Speakers",
			"long": "The AudioX system is an innovation in wet and warm environment audio. The AudioX offers exquisite sound and performance, enhancing and elevating the steam room and the entire bathroom experience to new heights.",
			"tech": "<li>AudioX System is fully Bluetooth enabled, offering amazing flexibility, connectivity, and control with smart devices</li><li>AudioX speakers are 75” square with a 5”mounting depth, designed to be flush mounted on the wall or ceiling</li><li>Comes with two, 6N/A-watt peak power speakers</li><li>With the SpaH2O mobile app, users can monitor and control the functionality of this completely digital control on any smart device</li><li>Available in both white and black finishes</li><li>Designed for use inside or outside the shower enclosure</li><li>Powerful bass, crystal-clear performance, with  full-range sound</li>"
		},
		"images": {
			"thumbnail": "AUDIOXBK.jpg",
			"folder": "spa-therapies/MsSpeakers/",
			"scene": "MsSpeakers-Square-Black.png"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/37d1a512-92f0-4089-bb89-b2dce30877ef.pdf"
		},
		"taxonomy": {
			"categories": [
				"spa-therapies"
			],
			"sortOrder": {
				"spa-therapies": 3
			},
			"zIndex": {
				"spa-therapies": 3
			}
		},
		"options": {
			"enabledListsIds": [
				"color"
			],
			"selected": {
				"color": "BLACK"
			},
			"list": {
				"color": [
					"BLACK",
					"WHITE"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "AUDIOXBK.jpg"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "AUDIOXWH.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "AUDIOXBK"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "AUDIOXWH"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.color"
				],
				"tallies": [
					{
						"tally": [
							[
								"BLACK"
							]
						],
						"value": "MsSpeakers-Square-Black.png"
					},
					{
						"tally": [
							[
								"WHITE"
							]
						],
						"value": "MsSpeakers-Square-White.png"
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 17,
					"left": 46.3,
					"width": 6,
					"height": 5,
					"orientation": "left"
				},
				{
					"top": 12,
					"left": 64.8,
					"width": 6,
					"height": 5,
					"orientation": "right"
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "104665",
		"partnumber": "104665",
		"previewname": "Shower Bench",
		"name": "Shower Bench",
		"price": 550,
		"descriptions": {
			"short": "Solid Surface Shower Bench",
			"long": "Sit down, relax, wash your troubles and the grime of the day away. It’s time to bathe in comfort and style. The MS Shower Bench is a sleek, contemporary addition to any shower or bathroom.",
			"tech": "<li>The MS Shower Bench is a complete white solid surface contruction</li><li>The MS Shower Bench is strong and sturdy with a 3N/AN/A lb weight capactiy</li><li>The MS Shower Bench can be used in wet or dry locations</li><li>The MS Shower bench has an elegant sophisticated design  and comfortably luxurious style</li><li>Shower bench dimensions 15 ¾” wide x 11 7/8” deep x 16¾” tall</li>"
		},
		"images": {
			"thumbnail": "104665.jpg",
			"folder": "accessories/WallSeat/",
			"scene": "mst2024-02_vspa_solid-surface-shower-bench_final_01.png"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/708fce30-8eb7-4ee4-9991-c1375a7f6adf.pdf"
		},
		"taxonomy": {
			"categories": [
				"accessories"
			],
			"sortOrder": {
				"accessories": 1
			},
			"zIndex": {
				"accessories": 1
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 66,
					"left": 56.5,
					"height": 7,
					"width": 13
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "SHOWERVALVE",
		"partnumber": "SHOWERVALVE",
		"previewname": "Shower Valve",
		"name": "Shower Valve",
		"price": 2000,
		"descriptions": {
			"short": "SpaH2O Electronic Shower Valve 120 VAC",
			"long": "The SpaH2O electronic shower valve syncs seamlessly with the iSteamX control for meticulous management of the water flow to your shower. The SPAH2O is a thermostatic pressure-balancing valve with an electronic mixer CPU that is directly controlled by the iSteamX.",
			"tech": "<li>The SpaH2O electronic shower valve offers 3 outputs</li><li>The SpaH2O user can program up to three custom user sequences</li><li>Streamlined maintenance, including built-in thermal disinfection and self-cleaning</li><li>The SpaH2O shower valve offers warm up and eco modes</li><li>Operating pressure range 3N/A - 1N/AN/A psi and 12N/A-degree Fahrenheit maximum hot water temperature control</li>"
		},
		"images": {
			"thumbnail": "SPAH2O.jpg",
			"folder": "controls-accessories/",
			"scene": "mst2024-02_vspa_SPAH2O-shower-valve_final_01.png"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/7b0f24da-3704-4761-9aa6-39b6a3027b71.pdf"
		},
		"taxonomy": {
			"categories": [
				"controls-accessories"
			],
			"sortOrder": {
				"controls-accessories": 1
			},
			"zIndex": {
				"controls-accessories": 1
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 66,
					"left": 56.5,
					"height": 7,
					"width": 13
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "TOWEL_WARMER_W228",
		"partnumber": "W228",
		"previewname": "Towel Warmer W228",
		"name": "Towel Warmer W228",
		"price": 1450,
		"descriptions": {
			"short": "Towel Warmer",
			"long": "Explore the Broadway Towel Warmer Collection. This collection will catch the eye with its classic design and is sure to leave you in a warm embrace and a comforting elevation of the senses.",
			"tech": "<li>Comes standard with a digital timer</li><li>Comes standard with a matching timer cover plate</li><li>Designed with a built-in AromaTherapy oil well</li><li>The Broadway collection is available in distinct designer finishes; Polished Chrome, Brushed Nickel, Brushed Bronze, and Mat Black</li>"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/e0a227c8-d556-4c39-9fdb-0110ec6bf4a4.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-200"
			],
			"series": "S200"
		},
		"images": {
			"folder": "towel-warmers/S200-Broadway/",
			"thumbnail": "W228TPC.jpg",
			"scene": "TowelWarmer-W228-PolishedChrome.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_NICKEL",
					"BRUSHED_BRONZE",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "W228TPC.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W228TBN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W228TBB.jpg"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W228TMB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "W228TPC"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W228TBN"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W228TBB"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W228TMB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "TowelWarmer-W228-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BN_final_01.png"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BB_final_01.png"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BM_final_01.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 1450
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": 1600
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": 1600
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": 1600
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 37,
					"left": 77.5,
					"height": 27,
					"width": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "TOWEL_WARMER_W236",
		"partnumber": "W236",
		"previewname": "Towel Warmer W236",
		"name": "Towel Warmer W236",
		"price": 1700,
		"descriptions": {
			"short": "Towel Warmer",
			"long": "Explore the Broadway Towel Warmer Collection. This collection will catch the eye with its classic design and is sure to leave you in a warm embrace and a comforting elevation of the senses.",
			"tech": "<li>Comes standard with a digital timer</li><li>Comes standard with a matching timer cover plate</li><li>Designed with a built-in AromaTherapy oil well</li><li>The Broadway collection is available in distinct designer finishes; Polished Chrome, Brushed Nickel, Brushed Bronze, and Mat Black</li>"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/e0a227c8-d556-4c39-9fdb-0110ec6bf4a4.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-200"
			],
			"series": "S200"
		},
		"images": {
			"folder": "towel-warmers/S200-Broadway/",
			"thumbnail": "W236TPC.jpg",
			"scene": "TowelWarmer-W228-PolishedChrome.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_NICKEL",
					"BRUSHED_BRONZE",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "W236TPC.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W236TBN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W236TBB.jpg"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W236TMB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "W236TPC"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W236TBN"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W236TBB"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W236TMB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "TowelWarmer-W228-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BN_final_01.png"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BB_final_01.png"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BM_final_01.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 1550
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": 1700
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": 1700
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": 1700
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 36,
					"left": 77.5,
					"height": 33,
					"width": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "TOWEL_WARMER_W248",
		"partnumber": "W248",
		"previewname": "Towel Warmer W248",
		"name": "Towel Warmer W248",
		"price": 1850,
		"descriptions": {
			"short": "Towel Warmer",
			"long": "Explore the Broadway Towel Warmer Collection. This collection will catch the eye with its classic design and is sure to leave you in a warm embrace and a comforting elevation of the senses.",
			"tech": "<li>Comes standard with a digital timer</li><li>Comes standard with a matching timer cover plate</li><li>Designed with a built-in AromaTherapy oil well</li><li>The Broadway collection is available in distinct designer finishes; Polished Chrome, Brushed Nickel, Brushed Bronze, and Mat Black</li>"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/e0a227c8-d556-4c39-9fdb-0110ec6bf4a4.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-200"
			],
			"series": "S200"
		},
		"images": {
			"folder": "towel-warmers/S200-Broadway/",
			"thumbnail": "W248TPC.jpg",
			"scene": "TowelWarmer-W228-PolishedChrome.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "POLISHED_CHROME"
			},
			"list": {
				"finish": [
					"POLISHED_CHROME",
					"BRUSHED_NICKEL",
					"BRUSHED_BRONZE",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "W248TPC.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W248TBN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W248TBB.jpg"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W248TMB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "W248TPC"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W248TBN"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W248TBB"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W248TMB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": "TowelWarmer-W228-PolishedChrome.png"
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BN_final_01.png"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BB_final_01.png"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_broadway_BM_final_01.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"POLISHED_CHROME"
							]
						],
						"value": 1700
					},
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": 1850
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": 1850
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": 1850
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 31,
					"left": 77.5,
					"height": 43,
					"width": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "TOWEL_WARMER_W328",
		"partnumber": "W328",
		"previewname": "Towel Warmer W328",
		"name": "Towel Warmer W328",
		"price": 1550,
		"descriptions": {
			"short": "Towel Warmer",
			"long": "Inspired by contemporary design and made with heating wire to lighten the weight, the Metro Collection brings home refined lines to complement the most stylish sanctuaries. It's a worthy match for your everyday routine-giving you a renewed sense of wellbeing everyday. Discover a new way to immerse your senses and surround yourself in aromatherapy. In addition to providing you a warm, dry towel after you bathe, this collection includes an essential oil well.",
			"tech": "<li>Comes standard with 24-hour digital timer and matching timer cover plate</li><li>Available in brushed stainless steel and polished stainless steel</li><li>The quality, design and performance you expect from a MrSteam product</li><li>Installation tools and kit included</li><li>Dimensions: 31.375”H × 20”W × 4.75”D </li><li>All models need to be hardwired to 120V</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/e12bad9c-8371-4732-a366-618fa0c54130.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-300"
			],
			"series": "S300"
		},
		"images": {
			"folder": "towel-warmers/S300-Metro/",
			"thumbnail": "W328TSSP.jpg",
			"scene": "TowelWarmer-W328-StainlessSteelPolished.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "STAINLESS_STEEL_POLISHED"
			},
			"list": {
				"finish": [
					"STAINLESS_STEEL_POLISHED",
					"STAINLESS_STEEL_BRUSHED"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "W328TSSP.jpg"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "W328TSSB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "W328TSSP"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "W328TSSB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "TowelWarmer-W328-StainlessSteelPolished.png"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "TowelWarmer-W328-StainlessSteelBrushed.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": 1550
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": 1550
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 36,
					"left": 77.5,
					"height": 26,
					"width": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "TOWEL_WARMER_W336",
		"partnumber": "W336",
		"previewname": "Towel Warmer W336",
		"name": "Towel Warmer W336",
		"price": 1675,
		"descriptions": {
			"short": "Towel Warmer",
			"long": "Inspired by contemporary design and made with heating wire to lighten the weight, the Metro Collection brings home refined lines to complement the most stylish sanctuaries. It's a worthy match for your everyday routine-giving you a renewed sense of wellbeing everyday. Discover a new way to immerse your senses and surround yourself in aromatherapy. In addition to providing you a warm, dry towel after you bathe, this collection includes an essential oil well.",
			"tech": "<li>Comes standard with 24-hour digital timer and matching timer cover plate</li><li>Available in brushed stainless steel and polished stainless steel</li><li>The quality, design and performance you expect from a MrSteam product</li><li>Installation tools and kit included</li><li>Dimensions: 38.875”H × 20”W × 4.75”D</li><li>All models need to be hardwired to 120V</li>"
		},
		"links": {
			"tech": "http://prodrep.mrsteam.com/DocumentResources/e12bad9c-8371-4732-a366-618fa0c54130.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-300"
			],
			"series": "S300"
		},
		"images": {
			"folder": "towel-warmers/S300-Metro/",
			"thumbnail": "W336TSSP.jpg",
			"scene": "TowelWarmer-W336-StainlessSteelPolished.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "STAINLESS_STEEL_POLISHED"
			},
			"list": {
				"finish": [
					"STAINLESS_STEEL_POLISHED",
					"STAINLESS_STEEL_BRUSHED"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "W336TSSP.jpg"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "W336TSSB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "W336TSSP"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "W336TSSB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": "TowelWarmer-W336-StainlessSteelPolished.png"
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": "TowelWarmer-W336-StainlessSteelBrushed.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"STAINLESS_STEEL_POLISHED"
							]
						],
						"value": 1675
					},
					{
						"tally": [
							[
								"STAINLESS_STEEL_BRUSHED"
							]
						],
						"value": 1675
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 35,
					"left": 77.5,
					"height": 34,
					"width": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	},
	{
		"code": "TOWEL_WARMER_W832",
		"partnumber": "W832",
		"previewname": "Towel Warmer W832",
		"name": "Towel Warmer W832",
		"price": 1400,
		"descriptions": {
			"short": "Towel Warmer",
			"long": "This towel warmer collection is properly named after the very hip and trendy art inspired streets of Tribeca NYC. This inspired collection will catch the eye, warm the heart, soothe the body, and leave you in a warm embrace.",
			"tech": "<li>The unique powder coated mat back color is heat cured to create a beautiful unique finish</li><li>Made with solid steel construction and is quality tested</li><li>Sturdy and solid contemporary design</li><li>Comes standard with a digital timer and cover plate</li>"
		},
		"links": {
			"tech": "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/58eb8561-b0e5-4675-828d-bb01d74e943a.pdf"
		},
		"taxonomy": {
			"categories": [
				"towel-warmers-800"
			],
			"series": "S800"
		},
		"images": {
			"folder": "towel-warmers/S800-Tribeca/",
			"thumbnail": "W832TBN.jpg",
			"scene": "mst2024-02_vspa_towel-warmer_tribeca_BN_final_01.png"
		},
		"options": {
			"enabledListsIds": [
				"finish"
			],
			"selected": {
				"finish": "BRUSHED_NICKEL"
			},
			"list": {
				"finish": [
					"BRUSHED_NICKEL",
					"BRUSHED_BRONZE",
					"MATTE_BLACK"
				]
			}
		},
		"dynamicProperties": {
			"images.thumbnail": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W832TBN.jpg"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W832TBB.jpg"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W832TMB.jpg"
					}
				]
			},
			"partnumber": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "W832TBN"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "W832TBB"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "W832TMB"
					}
				]
			},
			"images.scene": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_tribeca_BN_final_01.png"
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_tribeca_BB_final_01.png"
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": "mst2024-02_vspa_towel-warmer_tribeca_BM_final_01.png"
					}
				]
			},
			"price": {
				"keyTemplate": [
					"options.selected.finish"
				],
				"tallies": [
					{
						"tally": [
							[
								"BRUSHED_NICKEL"
							]
						],
						"value": 1400
					},
					{
						"tally": [
							[
								"BRUSHED_BRONZE"
							]
						],
						"value": 1400
					},
					{
						"tally": [
							[
								"MATTE_BLACK"
							]
						],
						"value": 1400
					}
				]
			}
		},
		"tooltips": {
			"list": [
				{
					"top": 31,
					"left": 77.5,
					"height": 43,
					"width": 11
				}
			]
		},
		"vSpa": {
			"spaFrameSourceOption": null,
			"spaFrameIsVisible": false,
			"standardGeneratorIsVisible": false,
			"isSuperCompatible": false
		}
	}
];


//////////////////
// WEBPACK FOOTER
// ./app/catalog/shared/data/products.json
// module id = 520
// module chunks = 1